export const languageKorean = {
    "formating": {
        "main": "메인 프롬프트",
        "jailbreak": "탈옥 프롬프트",
        "chats": "과거 채팅",
        "lorebook": "로어북",
        "globalNote": "글로벌 노트",
        "authorNote": "작가의 노트",
        "lastChat": "마지막 채팅",
        "description": "캐릭터 설명",
        "personaPrompt": "페르소나 프롬프트",
        "plain": "순수 프롬프트",
        "memory": "장기 기억",
        "postEverything": "최종 삽입 프롬프트"
    },
    "errors": {
        "toomuchtoken": "에러: 요청에 필요한 최소 토큰이 최대 토큰보다 큽니다.",
        "unknownModel": "에러: 알수없는 모델 선택됨",
        "httpError": "요청 에러:",
        "noData": "올바른 파일이 아니거나 데이터가 손상됐습니다.",
        "onlyOneChat": "채팅이 하나 이상 필요합니다",
        "alreadyCharInGroup": "이미 같은 캐릭터가 그룹에 존재합니다.",
        "noUserIcon": "유저 아이콘이 없습니다.",
        "emptyText": "텍스트가 비어있습니다.",
        "wrongPassword": "비밀번호가 잘못되었습니다.",
        "networkFetch": "네트워크가 불안정하거나 서버가 응답하지 않을 때 자주 발생합니다.",
        "networkFetchWeb": "이것은 CORS 오류일 수 있습니다. 이는 브라우저의 제한으로 인해 웹 버전을 사용할 때만 발생합니다. 데스크톱 로컬 버전이나 다른 버전의 Risuai를 사용해보세요.",
        "networkFetchPlain": "이것은 요청 오류일 수 있습니다. 설정에서 직접 요청 보내기 옵션을 비활성화해 보세요.",
        "requestLogRemoved": "요청 로그가 삭제되었습니다.",
        "requestLogRemovedDesc": "요청 로그는 앱이 재시작되거나 새로고침되면 삭제됩니다.",
        "vertexAuthError": "Vertex AI 인증 정보가 누락되었습니다.",
        "coldStorageWriteFailed": "콜드 스토리지 저장에 실패했습니다. 채팅 데이터는 보존되었습니다.",
        "coldStorageVerifyFailed": "콜드 스토리지 검증에 실패했습니다. 채팅 데이터는 보존되었습니다.",
        "coldStorageRestoreFailed": "콜드 스토리지 데이터를 불러올 수 없습니다. 해당 캐릭터의 데이터가 영구적으로 손실되었을 수 있습니다.",
        "coldStorageIncompleteBackupConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `${characterNames || "알 수 없는 캐릭터"}의 콜드 스토리지 데이터가 없거나 손상되었습니다.${unresolvedCount > 0 ? ` 캐릭터를 확인할 수 없는 항목이 ${unresolvedCount}개 있습니다.` : ""}\n\n계속하면 이 백업에서 콜드 스토리지 항목 ${unavailableCount}개가 누락되며, 해당 캐릭터 또는 채팅 데이터를 이 백업으로 복구하지 못할 수 있습니다.\n\n그래도 불완전한 백업을 생성하시겠습니까?`,
        "coldStorageIncompleteRestoreConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `${characterNames || "알 수 없는 캐릭터"}의 콜드 스토리지 데이터를 복원하지 못했습니다.${unresolvedCount > 0 ? ` 캐릭터를 확인할 수 없는 항목이 ${unresolvedCount}개 있습니다.` : ""}\n\n계속하면 콜드 스토리지 항목 ${unavailableCount}개를 사용할 수 없으며, 해당 캐릭터 또는 채팅 데이터가 영구적으로 손실될 수 있습니다.\n\n그래도 불완전한 복원을 계속하시겠습니까?`
    },
    "showHelp": "도움말 보기",
    "help": {
        "model": "채팅에서 사용되는 모델입니다.",
        "submodel": "보조 모델은 감정 이미지, 자동 제안등을 분석하는 데 사용되는 모델입니다. gpt3.5가 권장됩니다.",
        "oaiapikey": "OpenAI용 API 키입니다. https://platform.openai.com/account/api-keys에서 구하실 수 있습니다.",
        "mainprompt": "모델의 기본적인 방향성을 정하는 프롬프트입니다.",
        "jailbreak": "jailbreak 프롬프트는 jailbreak 토글이 켜져있을 때 작동되는 프롬프트입니다.",
        "globalNote": "모델에 강력한 영향을 주는 프롬프트입니다. UJB라고도 합니다.",
        "autoSuggest": "자동으로 유저의 응답을 제안할 때 선택지를 생성하기 위해 사용되는 프롬프트입니다.",
        "formatOrder": "프롬프트의 배치 순서입니다. 아래쪽에 있을 수록 더 큰 영향을 줍니다.",
        "forceUrl": "공백이 아닐 경우. 리퀘스트가 다음 URL로 갑니다.",
        "tempature": "값이 낮을수록 캐릭터가 프롬프트를 잘 따르지만 기계처럼 반응할 가능성이 높아집니다.\n값이 높을수록 창의적인 동작이 가능하지만 캐릭터의 반응이 이상해질 수 있습니다.",
        "frequencyPenalty": "값이 높을수록 응답 내에서 대사가 반복되는 걸 줄여주지만, 값이 높으면 캐릭터의 반응이 이상해질 수 있습니다.",
        "presensePenalty": "값이 높을수록 전체 콘텍스트 내에서 대사가 반복되는 걸 줄여주지만, 값이 높으면 캐릭터의 반응이 이상해질 수 있습니다.",
        "sdProvider": "이미지 생성의 제공자 옵션입니다.",
        "msgSound": "메세지를 받았을때 *띵* 소리가 납니다.",
        "charDesc": "캐릭터의 설명입니다.",
        "charFirstMessage": "캐릭터의 첫 대사입니다.",
        "charNote": "모델에 강력한 영향을 주는 프롬프트입니다. 이 채팅에서만 적용되며, 메모리라고도 알려져 있습니다.",
        "toggleNsfw": "jailbreak 프롬프트를 끄거나 켭니다.",
        "lorebook": " AI를 위해 사용자가 만든 사전입니다. AI는 컨텍스트에서 활성화 키가 어디에 있을 때만 이를 인식합니다.",
        "loreName": "로어의 이름입니다. AI에 영향을 주지 않습니다.",
        "loreActivationKey": "활성화 키 중 하나가 컨텍스트에 존재하면 해당 로어가 활성화됩니다. 쉼표로 구분된 활성화를 구분하세요.",
        "loreorder": "순서가 높을수록 모델에 더 많은 영향을 미치며, 활성화된 로어가 많을 때 잘리지 않습니다.",
        "bias": "바이어스는 문자열이 나타날 가능성을 수정하는 키-값 데이터로, -100에서 100까지 가능하며 값이 클수록 나타날 가능성이 높고, 값이 작을수록 나타날 가능성이 낮습니다 \n경고: 토크나이저가 잘못되면 제대로 작동하지 않습니다. 추가적으로, -101로 설정하면 일부 모델에서는 '강력한 단어 밴'으로 작동합니다",
        "emotion": "감정 이미지 옵션은 캐릭터의 반응으로 분석된 캐릭터의 감정에 따라 이미지를 표시합니다. 감정 이름은 단어 *(예시: joy, happy, fear 등)* 로 입력해야 하며, **neutral** 이라는 이름의 감정이 존재하면 기본 감정이 됩니다. 제대로 작동하려면 이미지가 3개 이상이어야 합니다.",
        "imggen": "채팅을 분석한 후 프롬프트를 {{slot}}에 적용합니다.",
        "regexScript": "정규식 스크립트는 IN에 매칭되는 텍스트를 OUT으로 변경하는 스크립트입니다.\n\n네가지 옵션이 있습니다.\n\n- **입력문 수정** 유저의 입력을 수정합니다\n\n- **출력문 수정** 캐릭터의 출력을 수정합니다\n\n- **리퀘스트 데이터 수정** 리퀘스트 시 데이터를 수정합니다\n\n- **디스플레이 수정** 실제 데이터를 건들지 않고, 표시되는 것만 수정합니다.\n\nIN은 슬래시와 플레그가 없는 정규식이여야 합니다.\n\nOUT은 특수한 패턴이 포함될수 있는 문자열입니다. 패턴은 다음과 같습니다:\n\n- $$\n\n    - inserts $\n\n- $&\n\n    - inserts the matched substring.\n\n- $`\n\n    - inserts the portion of the string that precedes the matched substring.\n\n- $1\n\n    - inserts the first matching group. works with other number like 2, 3...\n\n- $(name)\n\n    - inserts the named group\n\nOUT이 **@@**로 시작 시, 문자열을 교체하지 않고, 특수한 효과를 냅니다. 효과는 다음과 같습니다:\n\n- @@emo (emotion name)\n\n    - 캐릭터가 감정 이미지 모드일시, 감정을 (emotion name)으로 정하고 감정을 더이상 교체하지 않습니다.",
        "experimental": "실험적 기능입니다. 불안정할 수 있습니다.",
        "oogaboogaURL": "웹 UI가 이전 버전의 API를 지원하는 경우, URL은 *https:.../run/textgen*과 같아야 합니다.\n\n웹 UI가 새 버전의 API를 지원하는 경우, URL은 *https://.../api/v1/generate*와 같아야 하며, API 서버를 호스트로 사용하고 인수에 --api를 추가해야 합니다.",
        "exampleMessage": "캐릭터의 출력에 영향을 주는 예시 대화입니다. 토큰을 영구적으로 사용하지 않습니다.\n\n대화의 예시 형식:\n\n```\n<START>\n{{user}}: 안녕\n{{char}}: 안녕하세요\n<START>\n{{user}}: 안녕\n하루이: 안녕하세요\n```\n\n```<START>```는 새로운 대화의 시작을 나타냅니다.",
        "creatorQuotes": "캐릭터에 대한 정보를 사용자에게 알리기 위해 첫 번째 메시지 위에 나타납니다. 프롬프트에 포함되지 않습니다.",
        "systemPrompt": "메인 프롬프트가 비어있지 않은 경우 설정에서 메인 프롬프트를 대체하는 프롬프트입니다.",
        "chatNote": "현재 채팅에 포함되는 메모리 또는 UJB라고도 알려진 프롬프트입니다.",
        "personality": "캐릭터의 성격에 대한 간단한 설명입니다. **이 옵션을 사용하는 것은 권장되지 않습니다. 대신 캐릭터 설명에 설명하십시오.**",
        "scenario": "캐릭터의 시나리오에 대한 간단한 설명입니다. **이 옵션을 사용하는 것은 권장되지 않습니다. 대신 캐릭터 설명에 설명하십시오.**",
        "utilityBot": "활성화되면 메인 프롬프트, jailbreak 및 기타 프롬프트를 무시합니다. 역할극이 아닌 유틸리티용 봇에 사용됩니다.",
        "loreSelective": "선택 모드가 토글되면 활성화 키와 보조 키 모두 일치해야 로어가 활성화됩니다.",
        "loreRandomActivation": "확률 조건 사용이 활성화된 경우, 로어의 다른 조건이 모두 충족되면 로어가 활성화되며, 각 채팅을 보낼 때마다 설정된 확률에 따라 활성화됩니다.",
        "additionalAssets": "채팅에 표시할 추가 에셋입니다.\n\n- 경로로 사용하려면 `{{raw::<에셋 이름>}}`을\n- 이미지로 사용하려면 `{{image::<에셋 이름>}}`을\n- 비디오로 사용하려면 `{{video::<에셋 이름>}}`을\n- 오디오로 사용하려면 `{{audio::<에셋 이름>}}`을 사용하세요.\n",
        "superMemory": "SuperMemory는 AI에게 요약된 데이터를 제공하여 캐릭터가 더 많이 기억하도록합니다.\n\nSuperMemory 모델은 해당 텍스트를 요약하는 모델입니다. 보조 모델은 2000개 이상의 토큰을 가진 필터되지 않은 모델이 아닌 경우 권장되지 않습니다.\n\nSuperMemory 프롬프트는 요약을 보내기 위해 어떤 프롬프트를 보내야 하는지 결정합니다. 비워두면 기본 프롬프트를 사용합니다. 비워두는 것이 권장됩니다.\n\n모두 설정한 후 캐릭터의 설정에서 활성화할 수 있습니다.",
        "replaceGlobalNote": "비어 있지 않으면 현재 글로벌 노트를 이로 대체합니다.",
        "onboarding": "온보딩은 채팅을 시작하기 전에 사용자가 선택지를 고를 수 있게 해주는 간단한 설문입니다. 각 답변은 채팅 변수에 저장되며 `{{getvar::이름}}`이나 트리거에서 사용할 수 있습니다.\n\n사용자가 완료하거나 건너뛰기 전까지 채팅에 온보딩을 여는 배너가 표시됩니다. 채팅 메뉴에서 다시 열 수도 있습니다.\n\n**폼** 모드에서는 선택지와 텍스트 질문을 만들 수 있습니다. 다중 선택 답변은 JSON 배열로 저장됩니다.\n\n**HTML** 모드에서는 직접 레이아웃을 작성할 수 있습니다. 채팅 메시지와 동일하게 정화되며 `<style>`을 지원합니다. 요소에 `risu-change-var-name=\"변수명\"`과 `risu-change-var-value=\"값\"`을 추가하면 클릭 시 변수가 설정되고, 클릭된 요소에는 `selected` 클래스가 붙습니다. `<input>`, `<select>`, `<textarea>`에서는 입력값이 변수에 저장됩니다.",
        "backgroundHTML": "채팅 화면의 배경에 삽입 될 마크다운/HTML 데이터입니다.\n\n추가 에셋을 사용할 수도 있습니다. 예를 들어, 배경 음악에 `{{audio::<에셋 이름>}}`을 사용할 수 있습니다.\n\n또한 다음과 같은 추가 에셋을 사용할 수 있습니다:\n - `{{bg::<에셋 이름>}}`: 에셋으로 배경을 삽입합니다.",
        "additionalText": "AI가 필요한 경우에만 캐릭터 설명에 추가 될 텍스트입니다. 두 개의 새 줄로 구분합니다.",
        "charjs": "캐릭터와 함께 실행될 자바스크립트 코드입니다. 예를 들어, `https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js`를 확인할 수 있습니다. 현재 보안 문제로 인해 사용을 권장하지 않습니다. 엑스포트에는 포함되지 않습니다.",
        "romanizer": "로마자 변환기는 비로마자 문자를 로마자 문자로 변환하여 데이터 요청 시 비로마자 문자를 사용할 때 토큰을 줄이는 데 사용되는 플러그인입니다. 이로 인해 원래 모델과 다른 출력이 나올 수 있습니다. 채팅에서 로마자 문자를 사용할 때 이 플러그인을 사용하는 것은 권장되지 않습니다.",
        "inlayImages": "활성화하면 이미지를 채팅에 삽입할 수 있으며, 지원하는 경우 AI가 볼 수 있습니다.",
        "metrica": "Metric Systemizer는 요청 시 미터법을 제외한 단위를 미터법으로 변환하고, 출력 시 미터법을 사용하여 성능을 향상시키기 위해 사용되는 플러그인입니다. 채팅에서 야드파운드법을 사용할 때 이 플러그인을 사용하는 것은 권장되지 않습니다.",
        "lorePlus": "LoreBook+는 더 나은 매칭 성능을 위해 벡터DB를 사용하는 실험적인 기능입니다.",
        "topP": "Top P는 뉴클레우스 샘플링을 위한 확률 임계값입니다. 모델은 top_p 확률 질량을 가진 토큰의 결과를 고려합니다.",
        "openAIFixer": "OpenAI Fixer는 OpenAI의 일부 문제를 수정하는 플러그인입니다.",
        "sayNothing": "활성화되면 문자열이 입력되지 않을 때 '아무 말도 하지 않음'을 입력합니다.",
        "showUnrecommended": "활성화되면 권장되지 않는, 사용되지 않는 설정을 표시합니다. 이러한 설정을 사용하는 것을 권장하지 않습니다.",
        "streamingDisplayOptimizationMode": "정규식 스크립트처럼 후처리가 많은 상태에서 긴 응답을 스트리밍으로 받을 때 화면 버벅임을 줄입니다. 모바일 기기나 로우엔드 장비에서 유용할 수 있습니다.\n\n끄기는 일반 동작을 유지하지만, 매 토큰마다 후처리가 발생해 상당한 오버헤드를 유발할 수 있습니다.\n\n균형은 짧은 간격(약 0.125초) 단위로만 후처리를 시도하여 부하를 낮춥니다.\n\n강함은 균형과 비슷하지만 스트리밍 중에는 후처리를 건너뛰고, 스트리밍 완료 후 한 번만 후처리를 시도하여 부하를 크게 낮춥니다.\n\n이는 실험적 기능이며, 이로 인해 일부 기능이 의도하지 않은대로 동작할 수 있습니다.",
        "imageCompression": "활성화되면 캐릭터 내보내기 시 이미지를 압축합니다. 애니메이션 이미지가 작동하지 않는 경우 이 옵션을 비활성화해보세요.",
        "useExperimental": "활성화되면 일부 실험적인 기능이 표시됩니다.",
        "forceProxyAsOpenAI": "활성화되면 커스텀 모델 사용 시 OpenAI 형식을 강제로 사용합니다.",
        "forcePlainFetch": "활성화되면 네이티브 HTTP 요청 대신 브라우저 Fetch API를 사용합니다. 이로 인해 CORS 오류가 발생할 수 있습니다.",
        "autoFillRequestURL": "활성화되면 요청 URL을 현재 모델과 일치하도록 자동으로 채웁니다.",
        "chainOfThought": "활성화되면 생각의 사슬 프롬프트를 프롬프트에 추가합니다.",
        "gptVisionQuality": "이 옵션은 이미지 감지 모델의 품질을 설정하는 데 사용됩니다. 품질이 높을수록 감지가 더 정확하지만 토큰이 더 많이 사용됩니다.",
        "genTimes": "이 옵션은 지원 모델에서 생성할 응답 수를 설정하는 데 사용됩니다. 첫 번째 응답 이외의 다른 응답은 캐시된 리롤로 작동합니다. 이는 모델의 비용을 줄일 수 있지만, 리롤 없이 사용하는 경우 비용이 증가할 수도 있습니다.",
        "requestretrys": "이 옵션은 요청이 실패할 때 요청을 다시 시도할 횟수를 설정하는 데 사용됩니다.",
        "chatLoadInitialPages": "채팅 화면을 열 때 처음 렌더링할 최근 채팅 메시지 개수입니다. 값이 높을수록 더 많은 기록을 바로 볼 수 있지만 긴 채팅을 열 때 무거워질 수 있습니다.",
        "chatLoadAdditionalPages": "위로 스크롤할 때마다 추가로 렌더링할 이전 채팅 메시지 개수입니다. 값이 높을수록 반복 로딩은 줄지만 한 번의 로딩이 무거워질 수 있습니다.",
        "emotionPrompt": "이 옵션은 감정을 감지하는 데 사용되는 프롬프트를 설정하는 데 사용됩니다. 비어 있으면 기본 프롬프트를 사용합니다.",
        "removePunctuationHypa": "활성화되면 HypaMemory를 실행하기 전에 구두점을 제거합니다.",
        "additionalParams": "요청 본문에 추가될 파라미터입니다. 일부 파라미터를 제외하려면 `{{none}}`을 값으로 입력하세요. 본문 대신 헤더에 추가하려면 키 앞에 `header::Authorization`처럼 `header::`를 붙이세요. 값을 JSON으로 보내려면 값 앞에 `json::{\"key\":\"value\"}`처럼 `json::`을 붙이세요. 그렇지 않으면 값의 타입은 자동으로 결정됩니다.",
        "antiClaudeOverload": "Claude 과부하가 발생하면, Risuai는 동일한 프롬프트로 계속 진행하여 과부하 발생 가능성을 줄이려고 시도합니다. 스트리밍 응답에서만 작동합니다. 공식 API 엔드포인트가 아닌 경우 작동하지 않을 수 있습니다.",
        "triggerScript": "트리거 스크립트는 조건이 충족될 때 실행되는 커스텀 스크립트입니다. 채팅 데이터를 수정하거나, 명령어를 실행하거나, 변수를 변경하는 등의 작업에 사용할 수 있습니다. 실행 시점은 타입에 따라 다릅니다. {{button::Display::TriggerName}}을 사용하여 버튼으로 실행하거나, `risu-trigger=\"<TriggerName>\"` 속성이 있는 HTML 버튼으로도 실행할 수 있습니다.",
        "autoContinueChat": "활성화되면 문장 부호로 끝나지 않을 경우 채팅을 계속 이어가려고 시도합니다. 문장 부호를 사용하지 않는 언어에서는 사용하지 마세요.",
        "combineTranslation": "활성화된 경우, 한 문장이지만 HTML 태그로 분리된 텍스트를 모두 합쳐서 번역한 후, 번역된 결과에 다시 디스플레이 수정 스크립트를 적용합니다.\n이를 통해 번역기가 올바른 번역을 하도록 도와줍니다.\n이 옵션을 활성화하고 UI가 이상해지면 옵션을 끄고 제보해 주세요.",
        "dynamicAssets": "활성화되면 데이터 처리 중 에셋 이름을 찾을 수 없을 때, 벡터 검색을 사용하여 가장 유사한 에셋 이름을 찾아 대체합니다.",
        "dynamicAssetsEditDisplay": "활성화되면 동적 에셋이 디스플레이 수정 단계에도 적용됩니다. 단, 성능 문제가 발생할 수 있습니다.",
        "nickname": "닉네임이 설정되면 채팅에서 캐릭터 이름 대신 {{char}} 또는 <char>에 사용됩니다.",
        "useRegexLorebook": "활성화되면 로어북 검색에 문자열 일치 대신 정규식을 사용합니다. /regex/flags 형식을 사용합니다.",
        "customChainOfThought": "경고: 생각의 사슬 토글 사용은 더 이상 권장되지 않습니다. 대신 다른 프롬프트 항목에 생각의 사슬 프롬프트를 입력하세요.",
        "customPromptTemplateToggle": "여기서 고유한 프롬프트 토글을 정의할 수 있습니다. 개행으로 구분하여 `<토글 변수>=<토글 이름>` 형식을 사용하세요. 예: `cot=COT 토글`. 프롬프트에서 `{{getglobalvar::toggle_<토글 변수>}}`를 사용하여 이 토글을 사용할 수 있습니다. 예: `{{getglobalvar::toggle_cot}}`.",
        "defaultVariables": "여기에서는 기본 변수를 정의할 수 있습니다. `<변수 이름>=<변수 값>` 형식으로 작성하고 개행으로 구분합니다. 예를 들어, `name=Risuai`는 트리거 스크립트 및 변수 CBS와 함께 `{{getvar::A}}`, `{{setvar::A::B}}` 또는 `{{? $A + 1}}`과 같이 사용할 수 있습니다. 프롬프트 템플릿의 기본 변수와 캐릭터의 기본 변수가 동일한 이름을 가진 경우 캐릭터의 기본 변수가 사용됩니다.",
        "lowLevelAccess": "활성화되면 높은 컴퓨팅 파워가 필요한 기능과 캐릭터 트리거를 통한 AI 모델 실행에 대한 접근이 허용됩니다. 꼭 필요한 경우가 아니면 활성화하지 마세요.",
        "triggerLLMPrompt": "모델에 전송될 프롬프트입니다. `@@role user`, `@@role system`, `@@role assistant`를 사용하여 멀티 턴과 역할을 사용할 수 있습니다. 예:\n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "활성화되면 번역 후 후처리 대신 번역 전 마크다운과 따옴표를 전처리하는 이전 번역 방식을 사용합니다.",
        "luaHelp": "Lua 스크립트를 트리거 스크립트로 사용할 수 있습니다. onInput, onOutput, onStart 함수를 정의할 수 있습니다. onInput은 사용자가 메시지를 보낼 때, onOutput은 캐릭터가 메시지를 보낼 때, onStart는 채팅이 시작될 때 호출됩니다. 자세한 내용은 문서를 참조하세요.",
        "openAIFlexProcessing": "OpenAI Flex 응답은 일반 응답에 비해 느리지만, 더 저렴한 가격(배치 API 가격)에 응답을 받을 수 있습니다. 이 토글은 공식 OpenAI Chat Completions 요청에만 적용됩니다.",
        "claudeCachingExperimental": "Claude 캐싱은 모델 비용을 줄일 수 있는 실험적 기능이지만, 리롤 없이 사용하면 비용이 증가할 수도 있습니다. 실험적 기능이므로 불안정할 수 있으며 향후 동작이 변경될 수 있습니다.",
        "urllora": "모델 파일의 직접 다운로드 링크를 사용할 수 있습니다. https://sites.google.com/site/gdocs2direct/ 와 같은 웹사이트에서 구글 드라이브 직접 링크를 만들거나, civitai URL을 사용하거나, AIR (`urn:air:flux1:lora:civitai:180891@776656` 또는 `civitai:180891@776656`)를 복사하여 붙여넣으세요.",
        "v2GetAlertSelect": "선택지는 | 로 구분합니다.",
        "v2RegexTest": "정규표현식에 매칭이 되면 1, 매칭이 되지 않으면 0을 출력합니다.",
        "v2Calculate": "기본 산술 연산(+, -, *, /, %, ^), 비교 연산자(<, >, <=, >=, =, !=), 논리 연산자(&&, ||, !), 괄호를 사용한 우선순위 설정, $변수명 형태의 변수 치환을 지원하는 수학 표현식을 계산합니다. 변수는 자동으로 숫자로 변환되며 유효하지 않은 경우 0으로 처리됩니다.",
        "namespace": "네임스페이스는 모듈의 고유 식별자입니다. 모듈 간의 충돌을 방지하고 프리셋, 다른 모듈 등과의 상호 작용에 사용됩니다. 무엇을 입력해야 할지 모르면 비워두세요.",
        "moduleIntergration": "모듈 통합 섹션에 모듈 네임스페이스를 입력하여 모듈을 활성화할 수 있습니다. 여러 모듈을 활성화하려면 쉼표로 구분하세요. 예: `module1,module2,module3`. 프리셋에 따라 모듈 사용을 다르게 하고 싶은 고급 사용자를 위한 기능입니다.",
        "customCSS": "스타일링을 위한 커스텀 CSS입니다. 문제가 발생하면 (Ctrl + .)을 눌러 비활성화/활성화할 수 있습니다.",
        "betaMobileGUI": "활성화되면 작은 화면(800px 미만)에서 베타 모바일 GUI를 사용합니다. 새로고침이 필요합니다.",
        "enableScrollToActiveChar": "활성화되면 단축키를 누르거나 캐릭터를 드래그하는 동안 Ctrl을 누르면 현재 활성 캐릭터로 스크롤합니다. 폴더가 닫혀있으면 자동으로 열립니다.",
        "unrecommended": "비권장 설정입니다. 이 설정을 사용하는 것은 권장되지 않습니다.",
        "jsonSchema": "AI 모델이 JSON 스키마를 지원하는 경우 AI 모델로 전송될 JSON 스키마입니다.\n\n하지만 JSON 스키마는 배우기 어렵기 때문에, Risuai에서는 JSON 스키마 대신 TypeScript 인터페이스의 하위 집합을 사용할 수 있습니다. Risuai가 런타임에 이를 변환합니다. 예를 들어 다음과 같은 JSON을 보내고 싶다면:\n\n```js\n{\n  \"name\": \"Risuai\", //이름은 Risuai여야 함,\n  \"age\": 1, //나이는 숫자여야 함,\n  \"icon\": \"slim\", //아이콘은 'slim' 또는 'rounded'여야 함\n  \"thoughts\": [\"Good View!\", \"Lorem\"] //생각은 문자열 배열이어야 함\n}\n```\n\n다음과 같이 TypeScript 인터페이스를 입력할 수 있습니다:\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: 'slim'|'rounded'\n  thoughts: string[]\n}\n```\n\n인터페이스의 이름은 중요하지 않습니다. 자세한 내용은 TypeScript 문서를 참조하세요. (https://www.typescriptlang.org/docs/handbook/interfaces.html), 지원되는 TypeScript 하위 집합을 확인하려면 아래를 참조하세요.<details><summary>지원되는 TypeScript 하위 집합</summary>\n\n지원되는 타입은 `boolean`, `number`, `string`, `Array`입니다. 유닛 타입, 교차 타입, 유니온 타입, 옵셔널, 리터럴 타입 등 고급 타이핑은 다음 경우를 제외하고 지원되지 않습니다:\n\n        - 원시 타입의 배열: (예: `string[]`, `Array<boolean>)`\n        - 문자열 간의 유닛 타입: (예: `'slim'|'rounded'`).\n\n        속성은 한 줄에 하나씩 있어야 합니다. 한 줄에 여러 속성이 있으면 오류가 발생합니다. 속성 이름과 인터페이스 이름은 ASCII 범위 내의 라틴 문자만 사용해야 합니다. 속성 이름은 따옴표나 큰따옴표로 감싸지 않아야 합니다. 인터페이스 내부 중첩은 지원되지 않습니다. 속성이 정의된 줄에 `{` 또는 `}`를 넣을 수 없습니다. 더 고급 타입을 사용하려면 대신 JSON 스키마를 사용하세요.\n        </details>",
        "strictJsonSchema": "활성화되면 일부 모델에서 제공된 JSON 스키마를 엄격하게 따릅니다. 비활성화되면 JSON 스키마를 무시할 수도 있습니다.",
        "extractJson": "비워두지 않으면 응답에서 특정 JSON 데이터를 추출합니다. 예를 들어 `{\"response\": {\"text\": [\"hello\"]}}` 응답에서 `response.text[0]`을 추출하려면 `response.text.0`을 입력하세요.",
        "translatorNote": "여기에서 캐릭터마다 별도의 번역 프롬프트를 넣을 수 있습니다. 해당 옵션은  Ax. model 번역을 사용할 때만 적용됩니다. 언어 설정에서 `{{slot::tnote}}`를 넣으세요. 그룹챗에서는 작동하지 않습니다.",
        "groupInnerFormat": "화자가 아닌 캐릭터를 위해 그룹 채팅에서 사용되는 포맷을 정의합니다. 비워두지 않으면 기본 포맷 대신 이 포맷을 사용합니다. `그룹 내 기타 봇 역할`이 `assistant`인 경우 화자에게도 적용됩니다.",
        "groupOtherBotRole": "그룹 채팅에서 화자가 아닌 캐릭터에 사용되는 역할을 정의합니다.",
        "chatHTML": "각 채팅으로 삽입될 HTML입니다.\n\nCBS와 특수 태그를 사용할 수 있습니다.\n- `<risutextbox>`: 텍스트를 렌더링하는 데 사용될 텍스트 상자\n- `<risuicon>`: 사용자 또는 어시스턴트용 아이콘\n- `<risubuttons>`: 채팅 편집, 번역 등을 위한 아이콘 버튼\n- `<risugeninfo>`: 생성 정보 버튼.",
        "systemContentReplacement": "모델이 시스템 프롬프트를 지원하지 않는 경우 시스템 프롬프트를 대체하는 프롬프트 포맷입니다.",
        "systemRoleReplacement": "모델이 시스템 역할을 지원하지 않는 경우 시스템 역할을 대체하는 역할입니다.",
        "summarizationPrompt": "요약에 사용되는 프롬프트입니다. 비어있으면 기본 프롬프트를 사용합니다. 채팅 데이터에 대해 {{slot}}을 사용하여 ChatML 형식을 사용할 수도 있습니다.",
        "translatorPrompt": "번역에 사용되는 프롬프트입니다. 비어있으면 기본 프롬프트를 사용합니다. 목적 언어에 대해 {{slot}}, 콘텐츠에 대해 {{slot::content}}, 번역자 노트에 대해 {{slot::tnote}}를 사용하여 ChatML 형식을 사용할 수도 있습니다.",
        "translateBeforeHTMLFormatting": "활성화하면 정규식 스크립트와 HTML 포맷팅 전에 텍스트를 번역합니다. 토큰이 줄어들 수 있지만 포맷이 깨질 수 있습니다.",
        "autoTranslateCachedOnly": "자동 번역 옵션이 켜진 상태에서 활성화하면, 사용자가 이전에 번역한 메시지만 자동으로 번역됩니다.",
        "presetChain": "비어있지 않으면 사용자가 메시지를 보낼 때마다 이 입력의 프리셋 목록에서 무작위로 프리셋이 변경 및 적용됩니다. 프리셋 목록은 쉼표로 구분해야 합니다. 예: `preset1,preset2`.",
        "legacyMediaFindings": "활성화하면 추가 검색 알고리즘을 사용하지 않고 기존 방식으로 미디어 에셋을 찾습니다.",
        "comfyWorkflow": "Comfy UI의 API 워크플로우를 입력하세요. Comfy UI에서 'Workflow > Export (API)' 버튼을 눌러 API 워크플로우를 가져올 수 있습니다. 워크플로우 텍스트에 {{risu_prompt}}를 넣어야 하며, {{risu_prompt}}는 Risu에서 제공하는 프롬프트로 대체됩니다.",
        "automaticCachePoint": "채팅이 끝난 후 캐싱 포인트가 존재하지 않으면 자동으로 생성합니다.",
        "experimentalChatCompressionDesc": "사용하지 않는 채팅 데이터를 압축하여 별도 파일에 저장합니다. 채팅 데이터 크기를 크게 줄이고 성능을 크게 향상시키지만, 실험적 기능이며 불안정할 수 있어 백업 기능 등에서 문제를 일으킬 수 있습니다.",
        "promptInfoInsideChatDesc": "활성화되면 채팅 메타데이터에 프롬프트 프리셋 정보를 저장합니다. 저장되는 정보는 프롬프트 프리셋 이름과 활성화된 토글, 그리고 프롬프트 텍스트입니다. 약간의 처리 시간과 용량을 차지할 수 있습니다.",
        "autoAdjustSchema": "활성화하면 Dynamic Output을 위한 JSON 스키마가 자동으로 조정됩니다.",
        "dynamicMessages": "활성화하면 어시스턴트가 한 번에 하나씩이 아닌 여러 메시지를 연속으로 보낼 수 있습니다.",
        "dynamicMemory": "활성화하면 어시스턴트가 응답 시 메모리 노트를 작성합니다. 이 기능을 활용하려면 추가 프롬프팅이 필요합니다.",
        "dynamicResponseTiming": "활성화하면 응답 타이밍이 동적으로 조정됩니다.",
        "dynamicRequest": "활성화하면 사용자 입력을 기다리지 않고 무작위 타이밍에 모델에 요청합니다.",
        "settingsCloseButtonSize": "설정 창 우측 상단의 닫기(X) 버튼 크기를 조절합니다. 기본값은 24입니다.",
        "showTypingEffect": "활성화하면 어시스턴트가 응답을 생성하는 동안 타이핑 표시기가 표시됩니다.",
        "dynamicOutputPrompt": "활성화하면 스키마 정보가 요청에 포함됩니다.",
        "realmDirectOpen": "활성화되면 RisuRealm 미리보기에서 캐릭터를 클릭할 때 캐릭터 설명이 바로 열립니다.",
        "openRouterProviderOrder": "사용할 제공자 순서입니다. 첫 번째 제공자가 먼저 사용되며, 제공자를 사용할 수 없는 경우 다음 제공자를 사용합니다. 자세한 내용은 https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers 를 참조하세요",
        "openRouterProviderOnly": "이 목록의 제공자만 사용합니다. 모든 제공자를 사용할 수 없는 경우 요청이 실패합니다. 자세한 내용은 https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers 를 참조하세요",
        "openRouterProviderIgnore": "이 목록의 제공자를 무시합니다. 모든 제공자가 무시되면 요청이 실패합니다. 자세한 내용은 https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers 를 참조하세요",
        "additionalPrompt": "프롬프트 선보정이 활성화되어 있을 때 메인 프롬프트 끝에 추가되는 텍스트입니다. 기본값은 'The assistant must act as {{char}}. user is {{user}}.'이며, 이를 통해 기본적인 롤플레이 맥락을 설정합니다.",
        "hideAllImagesDesc": "봇 아이콘, 봇 이미지 에셋, RisuRealm 표지 사진을 가립니다.",
        "embedding": "임베딩 모델은 여러 기능에서 유사도 검색에 사용됩니다:\n\n- **장기 기억**: HypaV2, HypaV3, Hanurai Memory, SupaMemory (HypaMemory 활성화 시)\n- **추가 텍스트**: 컨텍스트 기반 캐릭터 추가 정보 매칭\n- **동적 에셋**: 정확한 에셋 이름을 찾지 못했을 때 유사한 이름 검색\n- **트리거 스크립트**: 트리거 스크립트의 유사도 조건\n- **파일 첨부**: PDF/TXT/XML 첨부 파일 내 검색",
        "keepSessionAlive": "탭을 활성 상태로 유지하여 브라우저에서 비활성으로 인해 세션이 만료되는 것을 방지합니다. 적용하려면 새로고침이 필요할 수 있습니다.\n\n- **소리 사용**: 들리지 않는 저주파 음을 반복 재생하여 세션을 유지합니다. 대부분의 브라우저에서 호환성과 효과가 가장 좋은 방식으로 알려져 있습니다. Android에서는 활성화되어 있는 동안 미디어 알림이 표시되며, 다른 음악 앱이 일시정지될 수 있습니다.\n",
        "reSummarizationPrompt": "벌크 수정에서 선택한 여러 요약을 하나로 합칠 때 사용되는 프롬프트입니다. 비어있으면 기본 프롬프트를 사용합니다.",
        "hypaV3MemoryTokensRatio": "프롬프트의 최대 컨텍스트 크기에서 장기기억 블록 {{slot}}에 할당되는 비율입니다.",
        "hypaV3ExtraSummarizationRatio": "요약이 멈추는 기준을 낮추는 비율입니다. 0이면 최대 컨텍스트 이하가 되었을 때 요약을 멈추고, 높을수록 더 많이 요약을 진행한 뒤 멈춥니다.",
        "hypaV3MaxChatsPerSummary": "하나의 요약본을 만들 때 포함할 최대 채팅 메시지 수입니다.",
        "hypaV3QueryChatCount": "유사도 검색의 쿼리로 사용되는 최근 채팅 메시지 수입니다. 값이 높을수록 더 많은 분량의 채팅으로 유사도를 판별합니다.",
        "hypaV3SummaryChunkSeparator": "요약본을 청크 단위로 분리할 때 사용되는 구분자입니다.",
        "hypaV3RecentMemoryRatio": "메모리 토큰 중 최근 메모리에 할당할 비율입니다. 가장 최근에 만들어진 요약본부터 할당된 토큰이 다 찰 때까지 자동으로 채워집니다.",
        "hypaV3SimilarMemoryRatio": "메모리 토큰 중 유사 메모리에 할당할 비율입니다. 최근 채팅과의 유사도 점수가 높은 요약본부터 할당된 토큰이 다 찰 때까지 자동으로 채워집니다.",
        "hypaV3RandomMemoryRatio": "이미 선택된 요약본을 제외한 나머지 중에서 무작위로 채워집니다.",
        "hypaV3PreserveOrphanedMemory": "활성화 시 삭제된 채팅 메시지를 참조하는 요약본이 보존됩니다. 비활성화하면 원본 메시지가 없어진 요약본이 자동으로 제거됩니다.",
        "hypaV3ProcessRegexScript": "활성화 시 HypaV3 모달에서 요약을 재생성할 때 입력되는 원본 채팅에 정규식 스크립트가 적용됩니다.",
        "hypaV3DoNotSummarizeUserMessage": "활성화 시 요약본당 최대 메시지 수에서 유저 메시지를 제외한 나머지만 요약에 사용됩니다.",
        "hypaV3EnableSimilarityCorrection": "활성화 시 최근 채팅 원문의 전체 요약본을 추가로 유사도 분석에 사용합니다. 실험적 하이파메모리 V3에서는 작동하지 않습니다.",
        "hypaV3UseExperimentalImpl": "실험적 하이파메모리 V3으로 전환합니다. Rate limit 설정이 가능해지고 쿼리 방식이 변경됩니다.",
        "hypaV3AlwaysToggleOn": "활성화 시 캐릭터를 선택할 때 하이파메모리 토글이 자동으로 활성화됩니다.",
        "hypaV3SummarizationRequestsPerMinute": "요약 시 분당 최대 수파메모리 모델 요청 수입니다. 수파메모리 모델이 보조 모델인 경우에만 적용됩니다.",
        "hypaV3SummarizationMaxConcurrent": "요약 시 최대 동시 수파메모리 모델 요청 수입니다. 수파메모리 모델이 보조 모델인 경우에만 적용됩니다.",
        "hypaV3EmbeddingRequestsPerMinute": "유사도 검색 시 분당 최대 임베딩 모델 요청 수입니다.",
        "hypaV3EmbeddingMaxConcurrent": "유사도 검색 시 최대 동시 임베딩 모델 요청 수입니다."
    },
    "setup": {
        "chooseProvider": "AI 제공자를 선택해 주세요",
        "openaikey": "OpenAI & API Key (권장)",
        "openaiProxy": "OpenAI 리버스 프록시",
        "setupmodelself": "그외 / 직접 설정",
        "inputApiKey": "여기에 API 키를 입력해주세요",
        "apiKeyhelp": "이곳에서 API키를 얻을 수 있습니다: ",
        "setupSelfHelp": "첫 셋업 화면이 끝난 뒤, 설정에서 직접 수정해 주세요",
        "theme": "테마를 입력해 주세요",
        "themeDescWifulike": "모바일에 적합하지 않습니다",
        "themeDescWifuCut": "모바일 환경에 적합합니다",
        "themeDescClassic": "모든 기기에 적합합니다",
        "texttheme": "텍스트 색상을 선택해주세요",
        "inputName": "마지막으로, 닉네임을 입력해 주세요",
        "welcome": "Risuai에 오신 것을 환영해요! 저는 Risuai 셋업을 도와줄 아이리스라고 해요. 먼저 닉네임을 입력해 주세요!",
        "welcome2": "{username}님 안녕하세요! Risuai를 시작하려면 몇 가지 설정만 하시면 되요. Ai 제공자를 선택해 주세요!",
        "openRouterProvider": "OpenRouter는 여러 무료/유료 모델이 있습니다. 기본적으로 무료로 설정됩니다.",
        "hordeProvider": "Horde는 특별한 설정이 필요없는 무료 모델입니다. 하지만, 성능이 좋지 않습니다.",
        "setProviderLater": "다른 설정을 먼저 하고, 나중에 설정해도 됩니다.",
        "setupOpenAI": "OpenAI를 사용하려면, API키가 필요해요. \n1. https://beta.openai.com/ 에 접속해주세요. \n2. 로그인 또는 회원가입 해주세요. \n3. https://beta.openai.com/account/api-keys 에 접속해주세요. \n4. 'Create New API Key'를 눌러주세요. \n5. 키 이름은 아무거나 하셔도 괜찮습니다. \n6.생성된 키를 복사해주세요.\n7. 리스AI로 돌아와 주세요.\n8. 입력칸에 붙여넣고, 전송 버튼을 눌러주세요.",
        "setupClaude": "Claude를 사용하려면 API키가 필요해요.",
        "setupClaudeSteps": [
            "이 URL로 이동하고 구글로 로그인하세요",
            "정보를 입력하고 'Continue'을 눌러주세요",
            "조직 페이지에서, 첫 번째 상자에 아무 이름만 입력하고 'Create Account'를 눌러주세요",
            "'Buy Credits' 버튼을 눌러주세요",
            "'Complete Setup' 버튼을 눌러주세요",
            "위 이미지와 같이 입력하되, 국가 부분은 자신의 국가를 입력해주세요. 그리고 'Continue'를 눌러주세요",
            "결제 방법을 추가하고 'Continue'를 눌러주세요",
            "결제가 등록되면 'Add Funds'를 눌러 자금을 추가하세요. 최소 5$를 추가할 수 있으며, 자동 추가 재충전을 설정할 수 있습니다.",
            "자금을 추가한 후, 대시보드 페이지로 이동하여 'Get API Keys' 버튼을 눌러주세요",
            "'Create API Key' 버튼을 눌러주세요",
            "위 이미지와 같이 입력하고 'Add'를 눌러주세요",
            "키를 복사하고, 이곳에 붙여넣고 전송해주세요."
        ],
        "setupOpenRouter": "OpenRouter를 사용하려면 API키가 필요합니다. \n1. https://openrouter.ai/keys 에 접속하고 로그인 또는 회원가입 해주세요.\n2. 'Create Key'를 눌러주세요. \n3. 키 이름은 아무거나 하셔도 괜찮습니다.\n4. 생성된 키를 복사해주세요.\n5. 리스AI로 돌아와주세요.\n6. 입력칸에 붙여넣고, 전송 버튼을 눌러주세요.",
        "allDone": "모든 설정이 끝났어요! 잠시만 기다려주세요. 나머지 작업은 제가 처리할게요.",
        "welcomeTitleName": "어떻게 불러드릴까요?",
        "welcomeTitleGuide": "설정을 도와드릴까요?",
        "welcomeTitleProvider": "AI 제공자를 선택해 주세요",
        "welcomeTitleApiKey": "API 키를 붙여넣어 주세요",
        "welcomeTitleChatLang": "대화 언어를 골라주세요",
        "welcomeTitleMemory": "기억력과 비용 중에 골라주세요",
        "welcomeTitleDone": "준비가 끝났어요!",
        "welcomeChangeLater": "모든 설정은 나중에 설정에서 바꿀 수 있어요.",
        "welcomeContinue": "계속",
        "setupLaterMessage": "{username}님 환영해요! 셋업을 직접 하겠어요? 아니면 제 가이드를 받아보실래요?",
        "setupMessageOption1": "셋업을 가이드해주세요",
        "setupMessageOption1Desc": "신규 사용자에게 추천합니다",
        "setupMessageOption2": "직접 설정하겠습니다",
        "claudeDesc": "Claude는 Antropic에서 만든 AI 모델로, 영어 이외의 언어를 사용한다면 OpenAI보다 더 나은 선택입니다.",
        "openAIDesc": "OpenAI GPT는 높은 품질의 AI 모델이지만, 유료이며 검열이 있으며, 영어 이외의 언어에서는 약합니다.",
        "chooseChatType": "채팅 언어를 선택해 주세요! 개인적으론, '언어에 집중하지 않음'을 추천해요!",
        "chooseChatTypeOption1": "전체 영어",
        "chooseChatTypeOption1Desc": "AI가 영어를 사용하고, 입력/출력이 영어로 됩니다. 영어 사용자에게 추천합니다.",
        "chooseChatTypeOption2": "영어 처리",
        "chooseChatTypeOption2Desc": "AI가 내부적으로 영어를 사용하지만, 입력/출력은 사용자의 언어로 됩니다. 영어 이외의 언어 사용자에게 추천합니다.",
        "chooseChatTypeOption3": "언어에 집중하지 않음",
        "chooseChatTypeOption3Desc": "AI가 내부적으로 사용자의 언어를 사용하지만, 품질이 낮아질 수 있습니다.",
        "chooseCheapOrMemory": "기억력과 가격 중 어느 것을 선호하세요? 잘 모르겠으면 균형으로 해주세요!",
        "chooseCheapOrMemoryOption1": "기억력",
        "chooseCheapOrMemoryOption1Desc": "AI가 더 많이 기억하지만, 비용이 많이 들 수 있습니다.",
        "chooseCheapOrMemoryOption2": "가격",
        "chooseCheapOrMemoryOption2Desc": "AI가 덜 기억하지만, 비용이 적게 들 수 있습니다.",
        "chooseCheapOrMemoryOption3": "균형",
        "chooseCheapOrMemoryOption3Desc": "AI가 가격보다는 더 많이 기억하지만, 기억보다는 적게 기억합니다.",
        "chooseCheapOrMemoryOption4": "무제한",
        "chooseCheapOrMemoryOption4Desc": "AI가 거의 모든 것을 기억하지만, 매우 비싸게 들 수 있습니다.",
        "finally": "아, 그리고 고급 도구를 활성화할까요? 처음이시라면 켜지 않는 것이 좋아요.",
        "finallyOption1": "예",
        "finallyOption1Desc": "이것은 고급 도구를 활성화하며, UI를 더 복잡하게 만듭니다. 고급 사용자에게 추천합니다.",
        "finallyOption2": "아니요",
        "finallyOption2Desc": "이것은 고급 도구를 비활성화하며, UI를 더 간단하게 만듭니다. 신규 사용자에게 추천합니다.",
        "igpPrompt": "IGP 프롬프트가 비어있지 않으면, 메인 모델 요청 후, 메인 모델 실행 후에 감정 모델로 실행되어 결과를 메인 모델 응답 뒤에 추가합니다."
    },
    "triggerCategories": {
        "Special": "특수",
        "Control": "제어",
        "Chat": "채팅",
        "Low Level": "저수준 접근",
        "Alert": "알림",
        "Lorebook V2": "로어북",
        "String": "문자열",
        "Data": "데이터",
        "Array": "배열",
        "Others": "기타",
        "Deprecated": "비권장"
    },
    "triggerDesc": {
        "v2Header": "헤더",
        "v2HeaderDesc": "헤더",
        "v2If": "만약 ~이라면",
        "v2IfDesc": "만약 {{source}} {{condition}} {{target}} 이라면",
        "v2Else": "아닐 경우",
        "v2ElseDesc": "아닐 경우",
        "v2EndIndent": "들여쓰기 끝",
        "v2EndIndentDesc": "들여쓰기 끝",
        "v2SetVar": "변수 설정",
        "v2SetVarDesc": "변수 {{var}} {{operator}} {{value}}",
        "v2Loop": "계속 반복하기",
        "v2LoopDesc": "계속 반복하기",
        "v2BreakLoop": "반복 중단",
        "v2BreakLoopDesc": "반복 중단",
        "v2RunTrigger": "트리거 실행",
        "v2RunTriggerDesc": "트리거 {{target}} 실행",
        "v2ConsoleLog": "콘솔 로그",
        "v2ConsoleLogDesc": "{{source}} 를 로그에 출력",
        "v2StopTrigger": "트리거 중단",
        "v2StopTriggerDesc": "트리거 중단",
        "v2CutChat": "대화 부분 잘라내기",
        "v2CutChatDesc": "{{start}} 에서 {{end}} 까지 대화 잘라내기",
        "v2ModifyChat": "대화 수정",
        "v2ModifyChatDesc": "인덱스 {{index}} 에 있는 대화를 {{value}} 로 수정",
        "v2SystemPrompt": "시스템 프롬프트 추가",
        "v2SystemPromptDesc": "{{location}} 에 시스템 프롬프트 {{value}} 추가",
        "v2Impersonate": "대화 보내기",
        "v2ImpersonateDesc": "{{role}} 대화 {{value}} 보내기",
        "v2Command": "명령어 실행",
        "v2CommandDesc": "{{value}} 명령어 실행",
        "v2SendAIprompt": "AI 프롬프트 전송",
        "v2SendAIpromptDesc": "AI 프롬프트 전송",
        "v2ImgGen": "이미지 생성",
        "v2ImgGenDesc": "{{value}} 프롬프트로 이미지 생성 => {{outputVar}}",
        "v2CheckSimilarity": "유사도 확인",
        "v2CheckSimilarityDesc": "{{source}} 와 {{value}} 의 유사도 확인 => {{outputVar}}",
        "v2RunLLM": "모델 실행",
        "v2RunLLMDesc": "{{value}} 을 모델에 요청 => {{outputVar}}",
        "v2ShowAlert": "알림 표시",
        "v2ShowAlertDesc": "{{value}} 로 알림 표시",
        "v2ExtractRegex": "정규식 추출",
        "v2ExtractRegexDesc": "{{value}} 에서 정규식  {{regex}} 및 플래그 {{flags}} 를 사용하여 텍스트 추출, 결과를 {{result}} 로 저장 => {{outputVar}}",
        "v2RegexTest": "정규식 테스트",
        "v2RegexTestDesc": "{{value}} 에서 정규식 {{regex}} 및 플래그 {{flags}} 로 매칭 테스트 => {{outputVar}}",
        "v2GetLastMessage": "마지막 메시지 가져오기",
        "v2GetLastMessageDesc": "마지막 메시지 가져오기 => {{outputVar}}",
        "v2GetMessageAtIndex": "인덱스에서 메시지 가져오기",
        "v2GetMessageAtIndexDesc": "인덱스 {{index}} 에서 메시지 가져오기 => {{outputVar}}",
        "v2GetMessageCount": "메시지 개수 가져오기",
        "v2GetMessageCountDesc": "메시지 개수 가져오기 => {{outputVar}}",
        "v2GetLorebook": "로어북 가져오기",
        "v2GetLorebookDesc": "로어북 {{target}} 가져오기 => {{outputVar}}",
        "v2GetLorebookCount": "로어북 개수 가져오기",
        "v2GetLorebookCountDesc": "로어북 개수 가져오기 => {{outputVar}}",
        "v2GetLorebookEntry": "인덱스에서 로어북 가져오기",
        "v2GetLorebookEntryDesc": "인덱스 {{index}} 에 있는 로어북 가져오기 => {{outputVar}}",
        "v2SetLorebookActivation": "로어북 활성화 설정",
        "v2SetLorebookActivationDesc": "인덱스 {{index}} 에 있는 로어북의 활성화 상태를 {{value}} 로 설정",
        "v2GetLorebookIndexViaName": "이름으로 로어북 인덱스 가져오기",
        "v2GetLorebookIndexViaNameDesc": "이름 {{name}} 인 로어북의 인덱스 가져오기 => {{outputVar}}",
        "v2ModifyLorebook": "로어북 수정",
        "v2ModifyLorebookDesc": "로어북 {{target}} 을 {{value}} 로 수정",
        "v2LoopNTimes": "N번 반복하기",
        "v2LoopNTimesDesc": "{{value}} 번 반복하기",
        "v2Random": "랜덤",
        "v2RandomDesc": "{{min}} 에서 {{max}} 까지의 랜덤 값 => {{outputVar}}",
        "v2GetCharAt": "문자열에서 N번째 문자 가져오기",
        "v2GetCharAtDesc": "{{source}} 의 {{index}} 번째 문자 가져오기 => {{outputVar}}",
        "v2GetCharCount": "문자 개수 가져오기",
        "v2GetCharCountDesc": "{{source}} 의 문자 개수 가져오기 => {{outputVar}}",
        "v2ToLowerCase": "소문자로 변환",
        "v2ToLowerCaseDesc": "{{source}} 를 소문자로 변환 => {{outputVar}}",
        "v2ToUpperCase": "대문자로 변환",
        "v2ToUpperCaseDesc": "{{source}} 를 대문자로 변환 => {{outputVar}}",
        "v2SetCharAt": "문자열의 N번째 문자 변경",
        "v2SetCharAtDesc": "{{source}} 의 {{index}} 번째 문자를 {{value}} 로 변경 => {{outputVar}}",
        "v2SplitString": "문자열 분할",
        "v2SplitStringDesc": "{{source}} 를 {{delimiter}} 로 분할 => {{outputVar}}",
        "v2GetCharacterDesc": "캐릭터 설명 가져오기",
        "v2GetCharacterDescDesc": "캐릭터 설명 가져오기 => {{outputVar}}",
        "v2SetCharacterDesc": "캐릭터 설명 설정",
        "v2SetCharacterDescDesc": "캐릭터 설명을 {{value}} 로 설정",
        "v2GetPersonaDesc": "페르소나 프롬프트 가져오기",
        "v2GetPersonaDescDesc": "페르소나 프롬프트 가져오기 => {{outputVar}}",
        "v2SetPersonaDesc": "페르소나 프롬프트 설정",
        "v2SetPersonaDescDesc": "페르소나 프롬프트를 {{value}} 로 설정",
        "v2GetReplaceGlobalNote": "글로벌 노트 덮어쓰기 가져오기",
        "v2GetReplaceGlobalNoteDesc": "글로벌 노트 덮어쓰기 가져오기 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "글로벌 노트 덮어쓰기 설정",
        "v2SetReplaceGlobalNoteDesc": "글로벌 노트 덮어쓰기를 {{value}} 로 설정",
        "v2GetAuthorNote": "작가의 노트 가져오기",
        "v2GetAuthorNoteDesc": "작가의 노트 가져오기 => {{outputVar}}",
        "v2SetAuthorNote": "작가의 노트 설정",
        "v2SetAuthorNoteDesc": "작가의 노트를 {{value}} 로 설정",
        "v2Comment": "주석 삽입",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "지역변수 선언",
        "v2DeclareLocalVarDesc": "지역변수 {{var}} 를 {{value}} 로 선언",
        "v2MakeArrayVar": "배열 변수 생성",
        "v2MakeArrayVarDesc": "배열 변수 {{var}} 생성",
        "v2GetArrayVarLength": "배열 변수 길이 가져오기",
        "v2GetArrayVarLengthDesc": "배열 변수 {{var}} 의 길이 가져오기 => {{outputVar}}",
        "v2GetArrayVar": "배열 변수 가져오기",
        "v2GetArrayVarDesc": "배열 변수 {{var}} 의 {{index}} 번째 값 가져오기 => {{outputVar}}",
        "v2SetArrayVar": "배열 변수 설정",
        "v2SetArrayVarDesc": "배열 변수 {{var}} 의 {{index}} 번째 값을 {{value}} 로 설정",
        "v2PushArrayVar": "배열 변수 가장 뒤에 값 추가",
        "v2PushArrayVarDesc": "배열 변수 {{var}} 의 가장 뒤에 {{value}} 추가",
        "v2PopArrayVar": "배열 변수에서 마지막 값 제거 후 가져오기",
        "v2PopArrayVarDesc": "배열 변수 {{var}} 에서 마지막 값 제거 => {{outputVar}}",
        "v2ShiftArrayVar": "배열 변수에서 첫 값 제거 후 가져오기",
        "v2ShiftArrayVarDesc": "배열 변수 {{var}} 에서 첫 값 제거 => {{outputVar}}",
        "v2UnshiftArrayVar": "배열 변수에 첫 값 추가",
        "v2UnshiftArrayVarDesc": "배열 변수 {{var} }에 {{value}} 첫 값으로 추가",
        "v2SpliceArrayVar": "배열 변수 가운데에 값 추가",
        "v2SpliceArrayVarDesc": "배열 변수 {{var}} 의 {{start}}에 {{item}} 추가",
        "v2SliceArrayVar": "배열 변수 슬라이스",
        "v2SliceArrayVarDesc": "배열 변수 {{var}} 의 {{start}} 부터 {{end}} 까지 슬라이스 => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "배열 변수에서 값의 인덱스 가져오기",
        "v2GetIndexOfValueInArrayVarDesc": "배열 변수 {{var}} 에서 값 {{value}} 의 인덱스 가져오기 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "배열 변수에서 인덱스에 있는 값 제거",
        "v2RemoveIndexFromArrayVarDesc": "배열 변수 {{var}} 에서 인덱스 {{index}} 에 있는 값 제거",
        "v2JoinArrayVar": "배열 결합",
        "v2JoinArrayVarDesc": "배열 {{var}} 를 {{delimiter}} 로 결합 => {{outputVar}}",
        "v2MakeDictVar": "딕셔너리 변수 생성",
        "v2MakeDictVarDesc": "딕셔너리 변수 {{var}} 생성",
        "v2GetDictVar": "딕셔너리 값 가져오기",
        "v2GetDictVarDesc": "딕셔너리 {{var}} 에서 키 {{key}} 의 값 가져오기 => {{outputVar}}",
        "v2SetDictVar": "딕셔너리 값 설정",
        "v2SetDictVarDesc": "딕셔너리 {{var}} 의 키 {{key}} 에 {{value}} 설정",
        "v2DeleteDictKey": "딕셔너리 키 삭제",
        "v2DeleteDictKeyDesc": "딕셔너리 {{var}} 에서 키 {{key}} 삭제",
        "v2HasDictKey": "딕셔너리 키 존재 확인",
        "v2HasDictKeyDesc": "딕셔너리 {{var}} 에 키 {{key}} 존재 확인 => {{outputVar}}",
        "v2ClearDict": "딕셔너리 비우기",
        "v2ClearDictDesc": "딕셔너리 {{var}} 비우기",
        "v2GetDictSize": "딕셔너리 크기 가져오기",
        "v2GetDictSizeDesc": "딕셔너리 {{var}} 의 크기 가져오기 => {{outputVar}}",
        "v2GetDictKeys": "딕셔너리 키 목록 가져오기",
        "v2GetDictKeysDesc": "딕셔너리 {{var}} 의 모든 키 가져오기 => {{outputVar}}",
        "v2GetDictValues": "딕셔너리 값 목록 가져오기",
        "v2GetDictValuesDesc": "딕셔너리 {{var}} 의 모든 값 가져오기 => {{outputVar}}",
        "v2ConcatString": "문자열 합치기",
        "v2ConcatStringDesc": "{{source1}} 와 {{source2}} 를 합치기 => {{outputVar}}",
        "v2GetLastUserMessage": "마지막 유저 메시지 가져오기",
        "v2GetLastUserMessageDesc": "마지막 유저 메시지 가져오기 => {{outputVar}}",
        "v2GetLastCharMessage": "마지막 캐릭터 메시지 가져오기",
        "v2GetLastCharMessageDesc": "마지막 캐릭터 메시지 가져오기 => {{outputVar}}",
        "v2GetFirstMessage": "첫 메시지 가져오기",
        "v2GetFirstMessageDesc": "첫 메시지 가져오기 => {{outputVar}}",
        "v2GetAlertInput": "알림 입력창",
        "v2GetAlertInputDesc": "알림 입력창 => {{outputVar}}",
        "v2GetAlertSelect": "알림 선택창",
        "v2GetAlertSelectDesc": "알림 선택창 {{display}} 선택지 {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "미지원 트리거",
        "v2UnsupportedTriggerDesc": "지원되지 않는 트리거",
        "v2GetDisplayState": "현재 디스플레이 데이터 가져오기",
        "v2GetDisplayStateDesc": "현재 디스플레이 테이터 가져오기 => {{outputVar}}",
        "v2SetDisplayState": "디스플레이 바꾸기",
        "v2SetDisplayStateDesc": "디스플레이 상태를 {{value}} 로 설정",
        "v2UpdateGUI": "GUI 업데이트",
        "v2UpdateGUIDesc": "GUI 업데이트",
        "v2UpdateChatAt": "인덱스의 채팅 업데이트",
        "v2UpdateChatAtDesc": "{{index}} 의 채팅 다시 그리기",
        "v2Wait": "기다리기",
        "v2WaitDesc": "{{value}} 초 기다리기",
        "v2GetRequestState": "리퀘스트 데이터 내용 가져오기",
        "v2GetRequestStateDesc": "{{index}} 에서 리퀘스트 내용 가져오기 => {{outputVar}}",
        "v2SetRequestState": "리퀘스트 데이터 내용 설정",
        "v2SetRequestStateDesc": "{{index}} 에 있는 리퀘스트 내용을 {{value}} 로 설정",
        "v2GetRequestStateRole": "리퀘스트 데이터 역할 가져오기",
        "v2GetRequestStateRoleDesc": "{{index}} 에서 리퀘스트 데이터 역할 가져오기 => {{outputVar}}",
        "v2SetRequestStateRole": "리퀘스트 데이터 역할 설정",
        "v2SetRequestStateRoleDesc": "{{index}} 에 있는 리퀘스트 데이터 역할을 {{value}} 로 설정",
        "v2GetRequestStateLength": "리퀘스트 데이터 길이 가져오기",
        "v2GetRequestStateLengthDesc": "리퀘스트 데이터 길이 가져오기 => {{outputVar}}",
        "v2IfAdvanced": "만약 ~이라면",
        "v2IfAdvancedDesc": "만약 {{source}} {{condition}} {{target}} 이라면",
        "v2QuickSearchChat": "빠른 채팅 검색",
        "v2QuickSearchChatDesc": "{{value}} 를 {{depth}} 깊이에서 {{condition}} 방식으로 검색 => {{outputVar}}",
        "v2StopPromptSending": "프롬프트 전송 중단",
        "v2StopPromptSendingDesc": "프롬프트 전송 중단",
        "v2Tokenize": "토큰화",
        "v2TokenizeDesc": "{{value}} 를 토큰화 => {{outputVar}}",
        "v2GetAllLorebooks": "전체 로어북 가져오기",
        "v2GetAllLorebooksDesc": "전체 로어북의 프롬프트를 배열로 가져오기 => {{outputVar}}",
        "v2GetLorebookByName": "이름으로 로어북 인덱스 가져오기",
        "v2GetLorebookByNameDesc": "이름 {{name}} 으로 로어북 인덱스 배열 가져오기 => {{outputVar}}",
        "v2GetLorebookByIndex": "로어북 가져오기",
        "v2GetLorebookByIndexDesc": "인덱스 {{index}} 의 로어북 프롬프트 가져오기 => {{outputVar}}",
        "v2CreateLorebook": "로어북 생성",
        "v2CreateLorebookDesc": "이름 {{name}}, 키 {{key}}, 내용 {{content}} 으로 로어북 생성",
        "v2ModifyLorebookByIndex": "로어북 수정",
        "v2ModifyLorebookByIndexDesc": "인덱스 {{index}} 의 로어북을 이름 {{name}}, 키 {{key}}, 내용 {{content}} 으로 수정",
        "v2DeleteLorebookByIndex": "로어북 삭제",
        "v2DeleteLorebookByIndexDesc": "인덱스 {{index}} 의 로어북 삭제",
        "v2GetLorebookCountNew": "로어북 개수 가져오기",
        "v2GetLorebookCountNewDesc": "전체 로어북 개수 가져오기 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "로어북 언제나 활성화 설정",
        "v2SetLorebookAlwaysActiveDesc": "인덱스 {{index}} 의 로어북 언제나 활성화를 {{value}} 로 설정",
        "v2Calculate": "연산",
        "v2CalculateDesc": "{{expression}} 연산 => {{outputVar}}",
        "v2ReplaceString": "문자열 치환",
        "v2ReplaceStringDesc": "{{source}} 에서 정규식 {{regex}} 를 {{replacement}} 로 치환 => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "값",
        "var": "변수",
        "varName": "변수명",
        "outputVar": "출력 변수",
        "name": "이름",
        "index": "인덱스",
        "source": "대상",
        "target": "타겟",
        "condition": "조건",
        "operator": "연산자",
        "role": "역할",
        "location": "위치",
        "prompt": "프롬프트",
        "model": "모델",
        "start": "시작",
        "end": "끝",
        "min": "최소값",
        "max": "최대값",
        "delimiter": "구분자",
        "depth": "깊이",
        "key": "키",
        "alertContent": "알림 내용",
        "options": "선택지",
        "cmd": "명령어",
        "regex": "정규식",
        "replacement": "치환값",
        "flags": "플래그",
        "negPrompt": "네거티브 프롬프트",
        "resultFormat": "결과 형식",
        "activationKeys": "활성화 키",
        "insertOrder": "배치 순서",
        "sysStart": "시스템 시작",
        "sysHistoryEnd": "시스템 히스토리 끝",
        "sysPromptEnd": "시스템 프롬프트 끝",
        "addElse": "else 추가",
        "alwaysActive": "항상 활성화",
        "trigger": "트리거",
        "triggerOn": "트리거 시점",
        "valueTypeDesc": "직접 입력한 값을 사용",
        "varTypeDesc": "변수에 저장된 값을 사용",
        "conditionEqual": "같음 (=)",
        "conditionNotEqual": "다름 (≠)",
        "conditionGreater": "큼 (>)",
        "conditionLess": "작음 (<)",
        "conditionGreaterEqual": "크거나 같음 (≥)",
        "conditionLessEqual": "작거나 같음 (≤)",
        "conditionSimilar": "유사 (≒)",
        "conditionContains": "포함 (∋)",
        "conditionIn": "속함 (∈)",
        "conditionNotContains": "포함하지 않음 (∌)",
        "conditionNotIn": "속하지 않음 (∉)",
        "conditionTruthy": "참 여부 (≡)",
        "operatorSet": "설정 (=)",
        "operatorAdd": "더하기 (+=)",
        "operatorSubtract": "빼기 (-=)",
        "operatorMultiply": "곱하기 (*=)",
        "operatorDivide": "나누기 (/=)",
        "operatorModulo": "나머지 (%=)",
        "searchLoose": "느슨한 검색",
        "searchStrict": "엄격한 검색",
        "searchRegex": "정규식 검색",
        "modelMain": "메인 모델",
        "modelSub": "보조 모델",
        "roleUser": "user",
        "roleChar": "char",
        "roleSystem": "system",
        "roleAssistant": "assistant",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "변수의 이름을 입력하세요",
        "helpOutputVar": "결과를 저장할 변수명을 입력하세요",
        "helpIndex": "배열이나 메시지의 인덱스 번호",
        "helpRegex": "정규식 패턴을 입력하세요",
        "helpFlags": "정규식 플래그",
        "helpDelimiter": "문자열을 나눌 구분자",
        "helpActivationKeys": "쉼표로 구분된 활성화 키워드",
        "helpInsertOrder": "삽입 순서",
        "helpDepth": "검색할 메시지 깊이",
        "helpMinMax": "최소값과 최대값 범위",
        "helpSlot": "변경하지 않으려면 {{slot}}을 사용하세요",
        "expression": "수식"
    },
    "playground": {
        "playground": "플레이그라운드",
        "inlayDeleteConfirm": "\"{name}\"을(를) 정말 삭제하시겠습니까?",
        "inlayDeleteMultipleConfirm": "선택한 {count}개의 에셋을 정말 삭제하시겠습니까?",
        "inlayDeleteSelected": "선택 항목 삭제",
        "inlayDeselectAll": "모두 선택 해제",
        "inlayEmpty": "저장된 인레이 에셋이 없습니다",
        "inlayEmptyDesc": "채팅에서 첨부 또는 생성된 이미지, 오디오 및 비디오가 여기에 나타납니다",
        "inlayExplorer": "인레이 에셋 탐색기",
        "inlaySelectAll": "모두 선택",
        "inlayTotalAssets": "총 {count}개 에셋",
    },
    "confirm": "확인",
    "goback": "뒤로",
    "botSettings": "봇 설정",
    "model": "모델",
    "apiKey": "API 키",
    "providerURL": "요청 URL",
    "providerJSON": "요청 JSON",
    "mainPrompt": "메인 프롬프트",
    "jailbreakPrompt": "탈옥 프롬프트",
    "globalNote": "글로벌 노트",
    "autoSuggest": "자동 제안",
    "tokens": "토큰",
    "maxContextSize": "최대 컨텍스트 크기",
    "maxResponseSize": "최대 응답 크기",
    "temperature": "온도",
    "frequencyPenalty": "빈도 패널티",
    "presensePenalty": "프리센스 패널티",
    "advancedSettings": "고급 설정",
    "advancedSettingsWarn": "어떤 설정인지 모르겠으면, 만지지 마세요!",
    "formatingOrder": "포맷 순서",
    "authorNote": "작가의 노트",
    "firstMessage": "첫 메시지",
    "description": "설명",
    "note": "메모",
    "jailbreakToggle": "탈옥 토글",
    "charIcon": "캐릭터 아이콘",
    "characterDisplay": "캐릭터 디스플레이",
    "viewScreen": "추가적 캐릭터 스크린",
    "none": "없음",
    "emotionImage": "감정 이미지",
    "noImages": "이미지 없음",
    "noBias": "Bias 없음",
    "image": "이미지",
    "name": "이름",
    "folderName": "폴더 이름",
    "folderRemoveConfirm": "이 폴더에는 로어북이 포함되어 있습니다. 폴더와 그 안의 모든 항목을 삭제하시겠습니까?",
    "emotion": "감정 이름",
    "value": "값",
    "reroll": "재생성",
    "chatList": "채팅 리스트",
    "removeChat": "이 메시지를 삭제하시겠습니까?",
    "loreBook": "로어북",
    "character": "캐릭터",
    "Chat": "챗",
    "globalLoreInfo": "캐릭터 로어북은 이 캐릭터의 모든 채팅에 적용됩니다.",
    "group": "그룹",
    "groupLoreInfo": "그룹 로어북은 이 그룹의 모든 채팅에 적용됩니다.",
    "localLoreInfo": "챗 로어북은 이 채팅에만 적용됩니다.",
    "removeConfirm": "정말로 삭제하시겠습니까: ",
    "removeConfirm2": "정말로, 정말로 삭제하시겠습니까: ",
    "exportConfirm": "엑스포트하시겠습니까?",
    "insertOrder": "배치 순서",
    "activationKeys": "활성화 키",
    "activationKeysInfo": "\",\"로 나눠주세요",
    "prompt": "프롬프트",
    "loreBookDepth": "로어북 검색 깊이",
    "loreBookToken": "로어북 최대 토큰",
    "chatLoadInitialPages": "채팅 초기 로딩 개수",
    "chatLoadAdditionalPages": "채팅 추가 로딩 개수",
    "removeCharacter": "캐릭터 삭제",
    "removeGroup": "그룹 삭제",
    "exportCharacter": "캐릭터 엑스포트",
    "userSetting": "유저 설정",
    "username": "유저 이름",
    "userIcon": "유저 아이콘",
    "successExport": "성공적으로 엑스포트하여 다운로드 경로에 다운로드했습니다.",
    "successImport": "성공적으로 임포트했습니다.",
    "importedCharacter": "성공적으로 임포트 됨.",
    "alwaysActive": "언제나 활성화",
    "additionalPrompt": "추가 프롬프트",
    "descriptionPrefix": "캐릭터 설명 Prefix",
    "forceReplaceUrl": "리버스 프록시",
    "emotionWarn": "채팅 분석에는 보조 모델을 사용합니다.",
    "plugin": "플러그인",
    "language": "언어",
    "UiLanguage": "UI 언어",
    "createfromScratch": "새 캐릭터 생성",
    "importCharacter": "캐릭터 임포트",
    "translator": "번역기",
    "disabled": "비활성화됨",
    "noPluginSelected": "플러그인이 선택되었지만, 플러그인이 없습니다.",
    "text": "텍스트",
    "UISize": "채팅 텍스트 크기",
    "newVersion": "업데이트가 발견되었습니다. 설치하시겠습니까?",
    "remindLaterQuestion": "며칠 뒤에 다시 알려드릴까요?",
    "remindIgnore": "무시",
    "remindLater1Day": "1일 뒤에 다시 알림",
    "remindLater3Days": "3일 뒤에 다시 알림",
    "remindLater5Days": "5일 뒤에 다시 알림",
    "remindLater1Week": "1주일 뒤에 다시 알림",
    "display": "소리 및 디스플레이",
    "useCustomBackground": "커스텀 배경",
    "translateInput": "입력창 번역하기",
    "autoTranslation": "자동 번역",
    "fullscreen": "전체 화면",
    "playMessage": "메시지 소리 출력",
    "iconSize": "아이콘 크기",
    "createGroup": "그룹 챗 만들기",
    "groupIcon": "그룹 아이콘",
    "single": "싱글",
    "multiple": "멀티플",
    "useCharLorebook": "캐릭터에 있는 로어 사용",
    "selectChar": "캐릭터 선택",
    "askLoadFirstMsg": "첫 메세지를 불러올까요?",
    "theme": "테마",
    "editOrder": "캐릭터 순서 변경",
    "autoMode": "오토 모드",
    "submodel": "보조 모델",
    "timeOutinSec": "타임아웃 (초)",
    "emotionPrompt": "감정 프롬프트",
    "singleView": "싱글",
    "SpacedView": "멀티플",
    "emphasizedView": "더블",
    "pluginWarn": "악성 플러그인 설치 시 문제가 생길 수 있습니다.",
    "pluginConfirm": "이 플러그인을 정말로 가져오시겠습니까? 신뢰할 수 있는 출처의 플러그인만 가져오세요.",
    "pluginContainsExternalMedia": "이 플러그인에는 외부 미디어가 포함되어 있습니다.",
    "pluginContainsExternalJS": "이 플러그인에는 외부 자바스크립트가 포함되어 있습니다.",
    "createGroupImg": "그룹 아이콘 자동생성",
    "waifuWidth": "Waifu 채팅창 넓이",
    "savebackup": "구글 백업 저장",
    "loadbackup": "구글 백업 불러오기",
    "files": "파일",
    "backupConfirm": "정말로 백업을 저장하시겠습니까?",
    "backupLoadConfirm": "정말로 백업을 불러오시겠습니까? 현재 데이터가 모두 사라집니다!",
    "backupLoadConfirm2": "정말로, 정말로 백업을 불러오시겠습니까? 현재 데이터가 모두 사라집니다!",
    "pasteAuthCode": "팝업에서 Auth Code를 복사하여 붙여넣기 해 주세요:",
    "driveAuthInvalid": "이 페이지에서 시작하지 않은 Google Drive 로그인이라 무시했습니다. 설정에서 백업 저장/불러오기를 다시 시작해주세요.",
    "others": "기타",
    "presets": "프리셋",
    "imageGeneration": "이미지 생성",
    "provider": "공급자",
    "key": "키",
    "noData": "데이터 없음",
    "currentImageGeneration": "현재 이미지 생성 데이터",
    "promptPreprocess": "프롬프트 선보정 사용",
    "SwipeRegenerate": "스와이프 리롤 사용",
    "instantRemove": "삭제 시 그 이후 채팅 삭제",
    "instantRemoveConfirm": "메시지 한개만 삭제하시겠습니까? No를 선택할 시, 그 이후 메시지또한 삭제됩니다.",
    "textColor": "텍스트 색상",
    "classicRisu": "클래식 Risu",
    "highcontrast": "고대비",
    "quickPreset": "Ctrl + (프리셋 번호)로 프리셋을 빠르게 변경할 수 있습니다",
    "requestretrys": "실패 시 재요청 횟수",
    "utilityBot": "유틸리티 봇",
    "ShowLog": "리퀘스트 로그 보기",
    "waifuWidth2": "Waifu 캐릭터 크기",
    "sayNothing": "어떤 문자열도 입력되지 않을 시 'say nothing' 입력",
    "regexScript": "정규식 스크립트",
    "type": "타입",
    "editInput": "입력문 수정",
    "editOutput": "출력문 수정",
    "editProcess": "리퀘스트 데이터 수정",
    "loadLatest": "가장 최근 백업 불러오기",
    "loadOthers": "다른 백업 불러오기",
    "exampleMessage": "예시 대화",
    "creatorNotes": "제작자 코멘트",
    "systemPrompt": "시스템 프롬프트",
    "characterNotes": "캐릭터 노트",
    "personality": "성격",
    "scenario": "시나리오",
    "alternateGreetings": "추가 첫 메시지",
    "unrecommended": "비권장",
    "chatNotes": "채팅 노트",
    "showUnrecommended": "비권장 설정 보이기",
    "streamingDisplayOptimizationMode": "스트리밍 표시 최적화",
    "streamingDisplayOptimizationOff": "끄기",
    "streamingDisplayOptimizationBalanced": "균형",
    "streamingDisplayOptimizationStrong": "강함",
    "altGreet": "추가 첫 메시지",
    "scripts": "스크립트",
    "settings": "설정",
    "selective": "멀티플 키",
    "SecondaryKeys": "두번째 키",
    "useGlobalSettings": "글로벌 설정 사용",
    "recursiveScanning": "재귀 검색",
    "creator": "제작자",
    "CharVersion": "캐릭터 버전",
    "Speech": "음성",
    "ToggleSuperMemory": "수파메모리 토글",
    "SuperMemory": "수파메모리",
    "useExperimental": "실험적 요소 보이기",
    "showMemoryLimit": "기억 한계치 보이기",
    "showFirstMessagePages": "퍼스트 메시지 페이지 보이기",
    "roundIcons": "둥근 아이콘",
    "streaming": "스트리밍",
    "chatBot": "채팅 봇",
    "otherBots": "기타 봇",
    "user": "유저",
    "additionalAssets": "추가 에셋",
    "editDisplay": "디스플레이 수정",
    "community": "커뮤니티",
    "textBackgrounds": "커스텀 채팅창 색깔",
    "textBorder": "텍스트 윤곽선",
    "textScreenRound": "둥근 채팅창",
    "textScreenBorder": "채팅창 윤곽선",
    "ttsReadOnlyQuoted": "따옴표 안 텍스트만 읽기",
    "ttsStop": "TTS 중지",
    "askRemoval": "삭제 확인",
    "replaceGlobalNote": "글로벌 노트 덮어쓰기",
    "charLoreBook": "캐릭터 로어북",
    "globalLoreBook": "글로벌 로어북",
    "globalRegexScript": "글로벌 정규식",
    "accessibility": "접근성",
    "sendWithEnter": "엔터키로 메세지 보내기(체크 해제시 Shift + Enter가 메세지 전송으로 변경.)",
    "fixedChatTextarea": "채팅창 하단 고정",
    "clickToEdit": "클릭해서 수정하기",
    "enableBlockPartialEdit": "블록 부분 수정 활성화 (블록에 마우스를 올려 개별 수정)",
    "enableDragPartialEdit": "드래그 부분 수정 활성화 (텍스트 선택 후 수정)",
    "setNodePassword": "보안을 위해 비밀번호를 정해주세요",
    "nodeSetupLinkRequired": "이 서버에는 아직 비밀번호가 없습니다. 서버 로그에 출력된 설정 링크(#setup=... 포함)를 열어 비밀번호를 정해주세요.",
    "inputNodePassword": "비밀번호를 입력해주세요. 기억이 안나신다면, save/__password를 지우고 서버를 재시작해주세요.",
    "simple": "간단",
    "advanced": "고급",
    "askReRollAutoSuggestions": "자동 제안 다시 뽑기",
    "creatingSuggestions": "응답 제안 작성 중...",
    "orderByOrder": "순서대로 말하기",
    "removeFromGroup": "정말로 {{char}}을 그룹에서 삭제시키겠습니까?",
    "talkness": "대화량",
    "active": "활성화",
    "loreRandomActivation": "확률 조건 사용",
    "activationProbability": "발동 확률",
    "shareCloud": "RisuRealm에 공유",
    "hub": "RisuRealm",
    "tags": "태그",
    "backgroundHTML": "백그라운드 임베딩",
    "copied": "복사됨",
    "useChatCopy": "채팅 메시지 복사 사용",
    "useChatSticker": "채팅 스티커 사용",
    "useAdditionalAssetsPreview": "추가 에셋 미리보기 사용",
    "autoTranslateInput": "입력 자동 번역",
    "enterMessageForTranslateToEnglish": "영어로 번역할 메시지를 입력해주세요",
    "recent": "최근",
    "downloads": "다운로드",
    "trending": "인기",
    "imageCompression": "이미지 압축",
    "notLoggedIn": "Risu Account에 로그인되지 않음",
    "googleDriveInfo": "구글 드라이브에 연동해서 데이터를 동기화하세요.",
    "googleDriveConnection": "구글 드라이브 연동하기",
    "googleDriveConnected": "구글 드라이브 연동됨",
    "SaveDataInAccount": "계정에 데이터 저장",
    "dataSavingInAccount": "계정에 데이터 저장 중",
    "logout": "로그아웃",
    "loadDataFromAccount": "계정에서 데이터 불러오기",
    "saveCurrentDataToAccount": "계정에 데이터 현재 덮어쓰기",
    "cancelAccountSync": "계정 연동 취소하기",
    "chatAssumed": "",
    "proxyAPIKey": "키/패스워드",
    "proxyRequestModel": "요청 모델",
    "officialWiki": "공식 위키",
    "officialWikiDesc": "리스AI의 공식 위키. 자유롭게 보세요.",
    "officialDiscord": "공식 디스코드",
    "officialDiscordDesc": "리스AI에 대해 자유롭게 대화하세요.",
    "persona": "페르소나",
    "icon": "아이콘",
    "account": "계정",
    "remove": "삭제",
    "able": "활성화됨",
    "close": "닫기",
    "assetWidth": "에셋 넓이",
    "animationSpeed": "에니메이션 속도",
    "screenshot": "스크린샷",
    "screenshotSaved": "스크린샷 저장됨",
    "createBotwithAI": "AI로 캐릭터 생성하기",
    "changeFolderName": "변경할 폴더 이름을 입력해주세요.",
    "cancel": "취소",
    "renameFolder": "폴더 이름 변경하기",
    "changeFolderColor": "폴더 색상 변경하기",
    "changeFolderImage": "폴더 이미지 변경하기",
    "fullWordMatching": "단어 단위 매칭",
    "botSettingAtStart": "실행 시 봇 설정으로 시작하기",
    "triggerStart": "채팅 보낼 시",
    "triggerInput": "유저 입력 시",
    "triggerOutput": "봇 출력 시",
    "triggerManual": "수동 트리거",
    "triggerCondVar": "만약 변수",
    "triggerCondExists": "만약 채팅에 텍스트 존재",
    "triggerScript": "트리거 스크립트",
    "triggerMatchRegex": "정규식 매칭",
    "triggerMatchLoose": "느슨한 매칭",
    "triggerMatchStrict": "정확한 매칭",
    "searchDepth": "검색 깊이",
    "equal": "같다면",
    "notEqual": "같지 않다면",
    "greater": "보다 크다면",
    "less": "보다 작다면",
    "greaterEqual": "크거나 같다면",
    "lessEqual": "작거나 같다면",
    "triggerEffSysPrompt": "시스템 프롬프트 추가",
    "triggerEffSetVar": "변수 변경",
    "triggerEffImperson": "채팅 보내기",
    "triggerEffCommand": "커맨드 실행",
    "triggerEffRunTrigger": "트리거 실행",
    "triggerEffStop": "프롬프트 중지",
    "triggerEffCall": "트리거 호출",
    "varableName": "변수 이름",
    "role": "역할",
    "location": "위치",
    "promptstart": "프롬프트 시작",
    "promptend": "프롬프트 끝",
    "historyend": "채팅 끝",
    "always": "언제나",
    "noEffect": "효과 없음",
    "invaildTriggerEffect": "이 효과는 이 트리거 타입에 사용할 수 없습니다.",
    "operator": "연산자",
    "TriggerSetToVar": "변수에 설정",
    "TriggerAddToVar": "변수에 더하기",
    "TriggerSubToVar": "변수에서 빼기",
    "TriggerMulToVar": "변수에 곱하기",
    "TriggerDivToVar": "변수에 나누기",
    "isNull": "값이 없다면",
    "ifChatIndex": "채팅 인덱스가",
    "ifRandom": "만약 랜덤",
    "ifValue": "값이 다음과 같다면",
    "hideRealm": "RisuRealm 숨기기",
    "blockRealmCreator": "제작자 차단",
    "blockRealmCreatorConfirm": "{{creator}} 제작자의 모든 RisuRealm 콘텐츠를 차단할까요?",
    "realmCreatorBlocked": "차단한 RisuRealm 제작자의 콘텐츠이므로 이용할 수 없습니다.",
    "realmCreatorBlockedSuccess": "제작자를 차단했습니다.",
    "manageBlockedRealmCreators": "차단한 제작자 관리",
    "blockedRealmCreators": "차단한 RisuRealm 제작자",
    "noBlockedRealmCreators": "차단한 RisuRealm 제작자가 없습니다.",
    "unblockRealmCreator": "차단 해제",
    "hideAllImages": "모든 이미지 숨기기",
    "popularityLevel": "{} 인기도",
    "colorScheme": "색상 팔레트",
    "rangeStart": "범위 시작",
    "rangeEnd": "범위 끝",
    "untilChatEnd": "채팅 끝까지",
    "usePromptTemplate": "프롬프트 템플릿 사용",
    "specialType": "특수 타입",
    "noSpecialType": "특수 타입 없음",
    "forceProxyAsOpenAI": "OpenAI 포맷으로 강제",
    "promptTemplate": "프롬프트 템플릿",
    "customInnerFormat": "커스텀 내부 포맷",
    "innerFormat": "내부 포맷",
    "HypaMemory": "하이파메모리",
    "ToggleHypaMemory": "하이파메모리 토글",
    "resetPromptTemplateConfirm": "정말로 프롬프트 템플릿을 초기화하시겠습니까?",
    "emotionMethod": "감정 방식",
    "continueResponse": "응답 계속하기",
    "showMenuChatList": "메뉴에서 채팅 리스트 보이기",
    "translatorLanguage": "번역기 언어",
    "translatorType": "번역기 타입",
    "htmlTranslation": "HTML 번역",
    "deeplKey": "deepL API 키",
    "deeplFreeKey": "deepL 무료 API 키",
    "deeplXUrl": "deepLX URL",
    "deeplXToken": "deepLX Token",
    "exportPersona": "페르소나 엑스포트",
    "importPersona": "페르소나 임포트",
    "export": "엑스포트",
    "import": "임포트",
    "supporterThanks": "후원자",
    "supporterThanksDesc": "후원자분들에게 감사합니다!",
    "donatorPatreonDesc": "기본적으로 개인정보 보호를 위해 목록에 표시되지 않습니다. 닉네임을 표시하려면 Risuai의 Patreon 페이지로 이동하여 링크 버튼을 누르세요.",
    "useNamePrefix": "이름을 프리픽스로 사용",
    "textAdventureNAI": "텍스트 어드벤쳐로 실행",
    "appendNameNAI": "NAI에서 이름을 텍스트 뒤에 붙이기",
    "customStopWords": "커스텀 정지 단어",
    "defaultPrompt": "기본 프롬프트",
    "additionalText": "추가 디스크립션",
    "seed": "시드",
    "charjs": "캐릭터JS",
    "depthPrompt": "깊이 프롬프트",
    "largePortrait": "세로 이미지",
    "lorePlus": "로어북+",
    "reverseProxyOobaMode": "Ooba 모드",
    "joinMultiUserRoom": "멀티 유저 룸 참가",
    "exactTokens": "정확 토큰",
    "fixedTokens": "대략적 토큰",
    "inlayViewScreen": "인레이 스크린",
    "imgGenPrompt": "이미지 생성 프롬프트",
    "imgGenNegatives": "이미지 생성 네거티브 프롬프트",
    "imgGenInstructions": "이미지 생성 지시사항",
    "usePlainFetchWarn": "NovelAI 사용 시 CORS 오류가 발생할 수 있으므로, NovelAI를 사용할 때는 이 옵션을 비활성화해 주세요.",
    "translationPrompt": "번역 프롬프트",
    "translationResponseSize": "번역 응답 크기",
    "webdeeplwarn": "이 옵션은 웹에서는 제대로 작동하지 않을 수 있습니다.",
    "saveBackupLocal": "로컬 백업 저장",
    "loadBackupLocal": "로컬 백업 불러오기",
    "topP": "Top P",
    "genTimes": "생성 횟수",
    "cot": "생각의 사슬",
    "forcePlainFetch": "직접 요청 보내기",
    "autoFillRequestURL": "요청 URL 자동 채우기",
    "newOAIHandle": "새로운 OpenAI 방식 적용",
    "inlayImage": "인레이 이미지",
    "nativeAutomark": "실험적 네이티브 오토마크 사용",
    "assistantPrefill": "어시스턴트 프리필",
    "postEndInnerFormat": "엔드 뒤 프롬프트",
    "sendChatAsSystem": "시스템으로 채팅 보내기",
    "sendName": "그룹챗 밖에서도 이름 붙이기",
    "utilOverride": "유틸리티 덮어쓰기",
    "template": "템플릿",
    "chatAsOriginalOnSystem": "기존 역할로 보내기",
    "exportAsDataset": "데이터셋으로 세이브 엑스포트",
    "editTranslationDisplay": "번역문 수정",
    "selectModel": "모델 선택",
    "autoRemoveThoughtTag": "Thought 태그 자동 제거",
    "customChainOfThought": "커스텀 생각의 사슬",
    "maxThoughtTagDepth": "Thought 태그 최대 깊이",
    "openRouterFallback": "폴백 사용",
    "openRouterMiddleOut": "미들 아웃 사용",
    "openRouterProviderOrder": "제공자 선호 순서",
    "openRouterProviderOnly": "허용할 제공자",
    "openRouterProviderIgnore": "무시할 제공자",
    "openRouterSearchModel": "모델 검색...",
    "openRouterSortByName": "이름 순",
    "openRouterSortByPrice": "가격 순",
    "openRouterSortByProvider": "회사 순",
    "openRouterSortAsc": "오름차순",
    "openRouterSortDesc": "내림차순",
    "geminiApiKey": "Gemini API Key",
    "removePunctuationHypa": "장기기억 내 문장부호 제거",
    "memoryLimitThickness": "기억 한계선 두께",
    "inputCardPassword": "카드 비밀번호 입력",
    "ccv2Desc": "Character Card V2은 챗봇 프로그램에서 자주 사용되는 포맷입니다.",
    "ccv3Desc": "Character Card V3은 발전된 기능을 제공하는 포맷입니다.",
    "realmDesc": "RisuRealm은 다양한 캐릭터를 공유하고, 다른 사용자의 캐릭터를 사용할 수 있는 플랫폼입니다.",
    "rccDesc": "미사용",
    "password": "비밀번호",
    "license": "라이센스",
    "licenseDesc": "라이센스는 다른 사용자가 이 캐릭터를 사용할 수 있는지 결정합니다.",
    "passwordDesc": "비밀번호를 설정하여 다른 사용자의 접근을 제한할 수 있습니다.",
    "largePersonaPortrait": "페르소나 세로 이미지",
    "module": "모듈",
    "modules": "모듈",
    "noModules": "모듈이 없습니다.",
    "createModule": "모듈 생성",
    "basicInfo": "기본 정보",
    "moduleContent": "모듈 내용",
    "confirmRemoveModuleFeature": "정말로 이 기능을 삭제하시겠습니까?",
    "editModule": "모듈 수정",
    "importModule": "모듈 임포트",
    "download": "다운로드",
    "edit": "수정",
    "enableGlobal": "글로벌 활성화",
    "chatModulesInfo": "모듈을 이 채팅 한정으로 활성화/비활성화합니다. 우클릭 또는 길게 눌러 캐릭터 한정으로 활성화/비활성화할 수 있습니다.",
    "sideMenuRerollButton": "사이드 메뉴 리롤 버튼",
    "persistentStorage": "영구 저장소",
    "persistentStorageSuccess": "저장소가 영구적으로 설정되었습니다.",
    "persistentStorageFail": "저장소 설정에 실패했습니다. 브라우저에서 거부되었을 수 있습니다.",
    "persistentStorageRecommended": "영구 저장소 권장됨",
    "persistentStorageDesc": "당신의 브라우저는 영구 저장소를 지원합니다. 이 기능을 활성화하면, 데이터가 브라우저에 더 오래 남습니다.",
    "enable": "활성화",
    "postFile": "파일 업로드",
    "requestInfoInsideChat": "채팅 내부에서 요청 정보 보이기",
    "inputTokens": "입력 토큰",
    "outputTokens": "출력 토큰",
    "tokenWarning": "토큰 계산은 정확하지 않을 수 있습니다. 참고용으로만 사용해주세요.",
    "log": "로그",
    "popularityLevelDesc": "인기도는 이 캐릭터가 얼마나 인기 있는지를 나타냅니다. 여러가지 요소가 영향을 미칩니다.",
    "additionalParams": "추가 파라미터",
    "heightMode": "높이 모드",
    "useAdvancedEditor": "고급 에디터 사용",
    "noWaitForTranslate": "번역 기다리지 않기",
    "updateRealm": "RisuRealm에 업데이트하기",
    "updateRealmDesc": "당신은 이 캐릭터를 RisuRealm에 업데이트 하려고 합니다. 이 작업은 취소할 수 없습니다.",
    "antiClaudeOverload": "Claude 오버로드 방지",
    "activeTabChange": "현재 탭이 비활성화되었습니다. OK를 누르면 탭이 다시 활성화됩니다.",
    "maxSupaChunkSize": "최대 수파메모리 청크 크기",
    "addCharacter": "캐릭터 추가",
    "importFromRealm": "RisuRealm에서 고르기",
    "importFromRealmDesc": "여러 캐릭터들이 공유된 RisuRealm에서 캐릭터를 고르세요.",
    "random": "랜덤",
    "metaData": "메타데이터",
    "autoContinueMinTokens": "타겟 토큰 (자동 컨티뉴)",
    "autoContinueChat": "불완전 문단 방지 (자동 컨티뉴)",
    "removeIncompleteResponse": "불완전 문단 제거",
    "tokenizer": "토크나이저",
    "chatFormating": "채팅 포맷",
    "useInstructPrompt": "인스트럭트 프롬프트 사용",
    "hanuraiMemory": "하느라이메모리",
    "textAreaSize": "텍스트 영역 크기",
    "textAreaTextSize": "텍스트 영역 텍스트 크기",
    "sideBarSize": "사이드바 크기",
    "embedding": "임베딩",
    "syntax": "문법",
    "run": "실행",
    "noMessage": "무언가 입력하여 채팅을 시작하세요.",
    "combineTranslation": "결합 번역",
    "dynamicAssets": "다이나믹 에셋",
    "dynamicAssetsEditDisplay": "디스플레이 수정에 다이나믹 에셋 사용",
    "longTermMemory": "장기기억",
    "grid": "그리드",
    "list": "리스트",
    "trash": "휴지통",
    "trashDesc": "삭제된 캐릭터는 휴지통에 보관됩니다. 복구하거나 영구 삭제할 수 있습니다. 3일 후에는 자동으로 영구 삭제됩니다.",
    "shareExport": "공유/엑스포트",
    "risupresetDesc": "Risupreset 포맷은 포맷을 공유하기 위한 Risuai 전용 포맷입니다.",
    "risuMDesc": "RisuM 포맷은 Risuai 모듈을 위해 특별히 설계된 포맷입니다.",
    "jsonDesc": "JSON은 데이터를 저장하고 불러오기 위한 일반적인 포맷입니다.",
    "nickname": "닉네임",
    "useRegexLorebook": "정규식 사용",
    "customPromptTemplateToggle": "커스텀 토글",
    "onboarding": "온보딩",
    "onboardingEnable": "온보딩 사용",
    "onboardingFloatingButton": "플로팅 버튼 표시",
    "onboardingAvailable": "이 캐릭터에는 온보딩이 있습니다",
    "onboardingAvailableDesc": "몇 가지 선택지를 골라 채팅을 설정하세요.",
    "onboardingSkip": "건너뛰기",
    "onboardingDone": "완료",
    "onboardingModeForm": "폼",
    "onboardingModeHTML": "HTML",
    "onboardingTitle": "제목",
    "onboardingQuestion": "질문",
    "onboardingAddQuestion": "질문 추가",
    "onboardingAddOption": "선택지 추가",
    "onboardingVarName": "변수 이름",
    "onboardingVarNameMissing": "변수 이름을 설정하지 않으면 이 질문은 표시되지 않습니다.",
    "onboardingTypeSingle": "단일 선택",
    "onboardingTypeMultiple": "다중 선택",
    "onboardingTypeText": "텍스트",
    "onboardingOptionLabel": "라벨",
    "onboardingOptionValue": "값 (비우면 라벨 사용)",
    "onboardingPlaceholder": "플레이스홀더",
    "onboardingRequired": "필수",
    "onboardingRequiredMissing": "필수 질문입니다.",
    "onboardingHTMLHint": "요소에 risu-change-var-name과 risu-change-var-value를 사용해 채팅 변수를 설정하세요. 클릭된 요소에는 .selected 클래스가 붙습니다.",
    "defaultVariables": "기본 변수",
    "hypaAllocatedTokens": "할당 토큰",
    "hypaChunkSize": "청크 크기",
    "hypaV2Desc": "하이파메모리 V2는 벡터 검색과 요약을 둘 다 사용하는 장기기억 시스템입니다.",
    "supaDesc": "수파메모리는 요약을 사용하는 장기기억 시스템입니다.",
    "hanuraiDesc": "하느라이메모리는 벡터 검색을 사용하는 장기기억 시스템입니다.",
    "lowLevelAccess": "저수준 접근",
    "resultStoredVar": "결과 저장 변수",
    "triggerEffRunLLM": "메인 모델 실행",
    "triggerEffectSendAI": "AI 재전송",
    "triggerEffCheckSim": "유사성 확인",
    "triggerEffShowAlert": "알림 보이기",
    "normal": "일반",
    "error": "에러",
    "input": "입력",
    "select": "선택",
    "options": "선택지",
    "alertContent": "알림 내용",
    "lowLevelAccessConfirm": "이 컨텐츠는 저수준 접근을 사용합니다. 이는 이 컨텐츠가 AI 모델과 당신의 저장소에 직접 접근할 수 있음을 의미합니다. 이 컨텐츠를 정말로 임포트하시겠습니까?",
    "triggerLowLevelOnly": "이 트리거는 저수준 접근만 사용할 수 있습니다. 이 트리거를 활성화하려면 캐릭터나 모듈의 고급 설정에서 저수준 접근을 활성화하세요.",
    "truthy": "참",
    "extractRegex": "정규식으로 텍스트 추출",
    "runImgGen": "이미지 생성 실행",
    "cutChat": "채팅 자르기",
    "modifyChat": "채팅 수정",
    "regex": "정규식",
    "flags": "플래그",
    "resultFormat": "결과 포맷",
    "negPrompt": "부정 프롬프트",
    "start": "시작",
    "end": "끝",
    "index": "인덱스",
    "search": "검색",
    "goCharacterOnImport": "임포트 시 캐릭터로 이동",
    "format": "포맷",
    "v2Warning": "주의: V2 카드는 더 이상 지원되지 않습니다. 일부 데이터가 누락될 수 있습니다.",
    "applyModule": "모듈 적용",
    "successApplyModule": "모듈이 성공적으로 적용되었습니다.",
    "font": "폰트",
    "lineHeight": "줄간격",
    "loadAutoServerBackup": "자동 서버 백업 불러오기",
    "notCharxWarn": "이 캐릭터는 여러 에셋을 사용합니다. 더 나은 호환성을 위해 이 캐릭터를 CharX 포맷으로 엑스포트하는 것이 좋습니다.",
    "noPlugins": "설치된 플러그인이 없습니다.",
    "legacyTranslation": "레거시 번역",
    "clipboardSuccess": "클립보드에 복사됨",
    "translateContent": "컨텐츠 번역",
    "doNotTranslate": "번역하지 않음",
    "includePersonaName": "페르소나 이름 포함",
    "hidePersonaName": "페르소나 이름 숨기기",
    "triggerSwitchWarn": "트리거 타입을 변경하면 현재 트리거가 손실됩니다. 계속하시겠습니까?",
    "codeMode": "코드",
    "blockMode": "블록",
    "helpBlock": "도움말",
    "hideChatIcon": "아이콘 UI 숨기기",
    "loadInternalBackup": "내부 백업 불러오기",
    "createCopy": "복사본 생성",
    "bindPersona": "페르소나 바인드",
    "chatOptions": "채팅 옵션",
    "doYouWantToBindCurrentPersona": "현재 페르소나를 이 채팅에 바인드하시겠습니까?",
    "doYouWantToUnbindCurrentPersona": "페르소나를 이 채팅에서 언바인드하시겠습니까?",
    "personaBindedSuccess": "페르소나가 성공적으로 바인드되었습니다.",
    "personaUnbindedSuccess": "페르소나가 성공적으로 언바인드되었습니다.",
    "parameters": "파라미터",
    "sizeAndSpeed": "크기와 속도",
    "useLegacyGUI": "레거시 GUI 사용",
    "claudeCachingExperimental": "클로드 캐싱",
    "openClose": "열기/닫기",
    "hideApiKeys": "API 키 숨기기",
    "unformatQuotes": "따옴표 포맷팅 비활성화",
    "enableDevTools": "개발자 도구 활성화",
    "selectFile": "파일 선택",
    "namespace": "네임스페이스",
    "moduleIntergration": "모듈 통합",
    "previewInfo": "미리보기는 모델 특화 처리 전에 프롬프트를 보여줍니다.",
    "miscTools": "기타 도구",
    "promptConvertion": "프롬프트 변환",
    "convertionStep1": "프롬프트와 관련된 모든 파일을 선택하세요 (컨텍스트, 인스트럭트, 샘플러 JSON을 지원합니다)",
    "customCSS": "커스텀 CSS",
    "betaMobileGUI": "베타 모바일 GUI",
    "enableScrollToActiveChar": "활성 캐릭터로 스크롤 활성화",
    "menu": "메뉴",
    "connectionOpen": "연결 열기",
    "connectionOpenInfo": "멀티유저 룸이 열렸습니다. 다른 사용자에게 룸 코드를 공유할 수 있습니다. 다른 사용자는 플레이그라운드 > 멀티유저 룸 참가에서 코드를 사용하여 룸에 참가할 수 있습니다.",
    "createMultiuserRoom": "멀티유저 룸 생성",
    "connectionHost": "당신은 룸의 호스트입니다.",
    "connectionGuest": "당신은 룸의 게스트입니다.",
    "otherUserRequesting": "다른 사용자가 이미 요청 중입니다. 나중에 다시 시도하세요.",
    "jsonSchema": "JSON 스키마",
    "enableJsonSchema": "스키마 활성화",
    "strictJsonSchema": "엄격한 스키마",
    "extractJson": "JSON 추출",
    "reloadSession": "새로운 세이브 데이터 버전이 발견되었습니다. 세션을 다시 로딩 중...",
    "fixMarkdownNewline": "마크다운 줄바꿈 수정",
    "customQuotes": "커스텀 따옴표",
    "leadingSingleQuote": "선행 단일 따옴표",
    "leadingDoubleQuote": "선행 이중 따옴표",
    "trailingSingleQuote": "후행 단일 따옴표",
    "trailingDoubleQuote": "후행 이중 따옴표",
    "translatorNote": "번역가의 노트",
    "formatGroupInSingle": "그룹을 하나로 포맷",
    "groupInnerFormat": "비화자 내부 포맷",
    "groupOtherBotRole": "그룹 내 비화자 역할",
    "defineCustomGUI": "커스텀 GUI 정의",
    "chatHTML": "채팅 HTML",
    "logShare": "공유 로그 버튼 보이기",
    "preview": "미리보기",
    "recommended": "추천",
    "newChat": "새 채팅",
    "predictedOutput": "출력 예측",
    "systemContentReplacement": "시스템 포맷 교체",
    "systemRoleReplacement": "시스템 역할 교체",
    "seperateParameters": "파라미터 분리",
    "seperateParametersEnabled": "파라미터 분리 활성화",
    "summarizationPrompt": "요약 프롬프트",
    "reSummarizationPrompt": "재요약 프롬프트",
    "translatorPrompt": "번역 프롬프트",
    "translateBeforeHTMLFormatting": "HTML 포맷 전 번역",
    "retranslate": "다시 번역",
    "editTranslation": "번역 수정",
    "editTranslationSave": "번역 저장",
    "exportTranslationCache": "번역 캐시 내보내기",
    "exportTranslationCacheSuccess": "번역 캐시를 내보냈습니다.",
    "importTranslationCache": "번역 캐시 가져오기",
    "importTranslationCacheConfirm": "번역 캐시에 항목을 병합합니다. 기존 키는 덮어씌워집니다. 계속하시겠습니까?",
    "importTranslationCacheSuccess": "번역 캐시 {0}개 항목을 가져왔습니다.",
    importTranslationCacheFailed: "{0}개의 항목을 가져왔지만, {1}개의 항목 저장에 실패했습니다. 저장 공간이 부족할 수 있습니다.",
    "exportTranslationCacheEmpty": "번역 캐시가 비어 있습니다.",
    clearTranslationCache: "번역 캐시 지우기",
    clearTranslationCacheSuccess: "번역 캐시를 지웠습니다.",
    clearTranslationCacheConfirm: "모든 번역 캐시 항목이 삭제됩니다. 되돌릴 수 없습니다. 계속하시겠습니까?",
    "loading": "로딩중",
    "autoTranslateCachedOnly": "캐시된 메시지만 자동 번역",
    "notification": "알림",
    "permissionDenied": "브라우저 또는 OS에 의해 권한이 거부되었습니다",
    "customFlags": "커스텀 플래그",
    "enableCustomFlags": "커스텀 플래그 활성화",
    "googleCloudTokenization": "Google Cloud 토큰화",
    "presetChain": "프리셋 체인",
    "legacyMediaFindings": "레거시 미디어 검색",
    "staticsDisclaimer": "통계는 2024년 7월 이후의 데이터를 기반으로 하며, 정확하지 않을 수 있습니다.",
    "subtitles": "자막",
    "subtitlesWarning1": "이 기능을 사용하려면 오디오/비디오 입력을 지원하는 모델을 사용해야 합니다.",
    "subtitlesWarning2": "이 기능을 사용하려면 스트리밍 기능을 지원하는 모델을 사용해야 합니다.",
    "reset": "초기화",
    "assetMaxDifference": "에셋 최대 차이",
    "sourceLanguage": "원본 언어",
    "destinationLanguage": "목표 언어",
    "noWebGPU": "브라우저 또는 OS가 WebGPU를 지원하지 않습니다. 이로 인해 성능이 크게 저하될 수 있습니다.",
    "menuSideBar": "메뉴 사이드바",
    "home": "홈",
    "showSavingIcon": "저장 아이콘 표시",
    "pluginVersionWarn": "이 플러그인은 {{plugin_version}} 버전입니다. 이 버전의 Risuai와 호환되지 않습니다. 플러그인을 {{required_version}} 버전으로 업데이트하세요.",
    "imageTranslation": "이미지 번역",
    "banCharacterset": "문자 집합으로 자동 재생성",
    "realmDirectOpen": "RisuRealm 미리보기에서 바로 열기",
    "showPromptComparison": "프롬프트 비교 보기",
    "inlayErrorResponse": "인레이 오류 응답",
    "triggerOn": "활성화 조건",
    "noConfig": "설정 없음",
    "varName": "변수 이름",
    "var": "변수",
    "condition": "조건",
    "trigger": "트리거",
    "outputVar": "출력 변수",
    "source": "출처",
    "cmd": "명령어",
    "sysStart": "시스템 시작",
    "sysHistoryEnd": "시스템 히스토리 끝",
    "sysPromptEnd": "시스템 프롬프트 끝",
    "target": "목표",
    "addElse": "그 외에 경우 추가",
    "min": "최소값",
    "max": "최대값",
    "delimiter": "구분자",
    "deleteCount": "삭제 개수",
    "triggerEffRunAxLLM": "보조 모델 실행",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3는 요약과 벡터 검색을 모두 사용하는 장기 기억 시스템입니다.",
        "supaMemoryPromptPlaceHolder": "기본값을 사용하려면 비워두세요",
        "maxMemoryTokensRatioLabel": "최대 메모리 토큰 비율 (추정)",
        "maxMemoryTokensRatioError": "최대 메모리 토큰 비율을 계산할 수 없습니다",
        "memoryTokensRatioLabel": "메모리 토큰 비율",
        "extraSummarizationRatioLabel": "추가 요약 비율",
        "maxChatsPerSummaryLabel": "요약본당 최대 메시지 수",
        "queryChatCountLabel": "쿼리 채팅 수",
        "summaryChunkSeparatorLabel": "청크 구분자 정규식",
        "recentMemoryRatioLabel": "최근 메모리 비율",
        "similarMemoryRatioLabel": "유사 메모리 비율",
        "randomMemoryRatioLabel": "무작위 메모리 비율",
        "enableSimilarityCorrectionLabel": "유사도 보정 활성화",
        "preserveOrphanedMemoryLabel": "고아 메모리 보존",
        "applyRegexScriptWhenRerollingLabel": "재생성 시 정규식 스크립트 적용",
        "doNotSummarizeUserMessageLabel": "유저 메시지 요약하지 않기"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "이 작업은 되돌릴 수 없습니다. HypaV3 데이터를 초기화하시겠습니까?",
        "resetConfirmSecondMessage": "이 작업은 복구할 수 없습니다. 정말로, 정말로 HypaV3 데이터를 초기화하시겠습니까?",
        "convertLabel": "아직 요약이 없지만, HypaV2 데이터를 V3로 변환할 수 있습니다.",
        "convertButton": "V3로 변환",
        "convertSuccessMessage": "HypaV2 데이터를 V3로 성공적으로 변환했습니다",
        "convertErrorMessage": "HypaV2 데이터를 V3로 변환하는데 실패했습니다: {0}",
        "noSummariesLabel": "아직 요약이 없습니다",
        "searchPlaceholder": "#N, ID 또는 검색어 입력",
        "summaryNumberLabel": "요약 #{0}",
        "deleteThisConfirmMessage": "이 요약을 삭제하시겠습니까?",
        "deleteAfterConfirmMessage": "이 요약 이후의 모든 요약을 삭제하시겠습니까?",
        "deleteAfterConfirmSecondMessage": "이 작업은 되돌릴 수 없습니다. 정말 삭제하시겠습니까?",
        "translationLabel": "번역",
        "rerolledSummaryLabel": "재생성된 요약",
        "rerolledTranslationLabel": "재생성된 요약 번역",
        "connectedMessageCountLabel": "연결된 메시지 ({0})",
        "connectedFirstMessageLabel": "첫 메시지",
        "connectedMessageRoleLabel": "{0}의 메시지",
        "connectedMessageNotFoundLabel": "메시지를 찾을 수 없습니다",
        "connectedMessageLoadingError": "연결된 메시지를 불러오는 동안 오류 발생: {0}",
        "connectedMessageTranslationLabel": "번역",
        "nextSummarizationFirstMessageLabel": "첫 메시지",
        "nextSummarizationNoMessageIdLabel": "메시지 ID 없음",
        "nextSummarizationLabel": "HypaV3가 [{0}]를 요약할 예정입니다",
        "nextSummarizationNoMessagesFoundLabel": "경고: 메시지를 찾을 수 없습니다",
        "nextSummarizationLoadingError": "다음 요약 대상을 불러오는 동안 오류 발생: {0}",
        "summarizationConditionLabel": "팁: HypaV3는 입력 토큰이 최대 컨텍스트 크기를 넘으면 요약을 시작합니다.",
        "emptySelectedFirstMessageLabel": "경고: 선택된 첫 메시지가 비어있습니다",
        "unclassified": "미분류",
        "reSummarize": "재요약",
        "reSummarizing": "재요약 중...",
        "reSummarizeResult": "재요약 결과",
        "retry": "재시도",
        "translate": "번역",
        "tag": "태그",
        "tagManager": "태그 관리",
        "tagManagerTitle": "태그 관리 - 요약본 #{0}",
        "newTagName": "새 태그 이름",
        "noTagsYet": "아직 태그가 없습니다.",
        "addNewTagHint": "위에서 새 태그를 추가해보세요.",
        "categoryManager": "카테고리",
        "allCategories": "전체",
        "categoryName": "카테고리 이름",
        "noCategoriesYet": "아직 카테고리가 없습니다.",
        "addNewCategoryHint": "위의 + 버튼을 클릭해서 추가해보세요."
    },
    "bulkEnabling": "한번에 로어북 활성화 버튼",
    "showTranslationLoading": "번역 로딩 보이기",
    "showDeprecatedTriggerV1": "비권장 트리거 V1 보이기",
    "showDeprecatedTriggerV2": "비권장 트리거 V2 보이기",
    "triggerV1Warning": "트리거 V1은 비권장입니다. 추후에 제거될 수 있습니다.",
    "copy": "복사",
    "paste": "붙여넣기",
    "depth": "깊이",
    "returnCSSError": "CSS 오류 반환",
    "alwaysActiveInChat": "언제나 활성화 (현재 챗)",
    "childLoreDesc": "이것은 캐릭터 로어의 복사본이며, 삭제하거나 원본 로어에서 직접 비활성화하기 전에는 '언제나 활성화' 상태로 유지됩니다.",
    "thinkingTokens": "사고 토큰",
    "thinkingType": "사고 모드",
    "adaptiveThinkingEffort": "적응형 사고 수준",
    "antiServerOverload": "서버 과부하 방지",
    "localActivationInGlobalLorebook": "글로벌 로어북에서 로컬 활성화",
    "cachePoint": "캐시 포인트",
    "all": "모두",
    "showFolderNameInIcon": "아이콘에 폴더 이름 표시",
    "claudeCachingRetrival": "Claude 캐싱 재활용",
    "claudeCachingRetrivalDesc": "4분마다 요청하여 Claude 캐싱의 캐시 시간을 연장합니다. 캐시 누락률을 줄일 수 있지만, 적절히 사용하지 않으면 비용이 증가할 수 있습니다.",
    "automaticCachePoint": "자동 캐시 포인트",
    "experimentalChatCompression": "실험적 채팅 데이터 처리",
    "loadingChatData": "채팅 데이터 로딩 중",
    "outputImageModal": "출력 이미지 모달",
    "playMessageOnTranslateEnd": "번역 완료 시 오디오 재생",
    "auxModelUnderModelSettings": "보조 모델 분리를 모델 설정에 표시",
    "seperateModelsForAxModels": "보조 모델 분리",
    "axModelsDef": "보조 모델 정의",
    "doNotChangeSeperateModels": "프리셋 변경 시 분리된 모델 변경하지 않기",
    "tools": "도구",
    "action": "동작",
    "hotkey": "단축키",
    "hotkeyDesc": {
        "reroll": "재생성",
        "unreroll": "재생성 취소",
        "translate": "번역",
        "remove": "제거",
        "edit": "편집",
        "copy": "복사",
        "send": "전송",
        "settings": "설정",
        "home": "홈",
        "presets": "빠른 프리셋 선택",
        "persona": "빠른 페르소나 선택",
        "modelSelect": "빠른 모델 선택",
        "toggleCSS": "CSS 토글",
        "prevChar": "이전 캐릭터",
        "nextChar": "다음 캐릭터",
        "quickMenu": "빠른 메뉴",
        "quickSettings": "빠른 설정",
        "toggleVoice": "음성 토글",
        "toggleLog": "로그 토글",
        "previewRequest": "요청 미리보기",
        "import": "가져오기",
        "export": "내보내기",
        "webcam": "웹캠 토글",
        "focusInput": "입력창 포커스",
        "scrollToActiveChar": "활성 캐릭터로 스크롤"
    },
    "screenTooSmall": "화면이 너무 작아서 인터페이스를 표시할 수 없습니다.",
    "advancedModelSettings": "고급 모델 설정",
    "fallbackModel": "대체 모델",
    "fallbackWhenBlankResponse": "빈 응답 시 대체",
    "doNotChangeFallbackModels": "프리셋 변경 시 대체 모델 변경 안 함",
    "customModels": "커스텀 모델",
    "igpPrompt": "IGP 프롬프트",
    "useTokenizerCaching": "토크나이저 캐싱",
    "hypaMemoryV2Modal": "하이파 V2 모달",
    "hypaMemoryV3Modal": "하이파 V3 모달",
    "showMenuHypaMemoryModal": "메뉴에서 하이파 모달 보이기",
    "promptInfoInsideChat": "채팅에 프롬프트 정보 추가하기",
    "promptTextInfoInsideChat": "채팅에 프롬프트 텍스트 정보 추가하기",
    "promptInfoEmptyMessage": "이 메시지에 대한 프롬프트 정보가 없습니다.",
    "promptInfoEmptyToggle": "활성화된 커스텀 토글이 없습니다.",
    "promptInfoEmptyText": "저장된 프롬프트 텍스트가 없습니다.",
    "escapeOutput": "출력 이스케이프",
    "openAIFlexProcessing": "OpenAI Flex 처리",
    "claudeBatching": "Claude 배칭",
    "claude1HourCaching": "Claude 1시간 캐싱",
    "folderNameInput": "새 폴더 이름을 입력해주세요",
    "folderRemoveLengthError": "폴더를 제거하려면 폴더가 비어 있어야 합니다.",
    "personaNotePlaceholder": "이 페르소나를 구분할 고유 식별자를 입력하세요. 예: \"헌터 페르소나\"",
    "mcpAccessPrompt": "{{tool}}이(가) \"{{action}}\"을(를) 시도하고 있습니다. 허용하시겠습니까?",
    "rememberToolUsage": "도구 사용 기억하기",
    "simplifiedToolUse": "단순화된 도구 사용",
    "toolCalled": "도구 '{{tool}}' 호출됨",
    "static": "정적",
    "dynamic": "동적",
    "assetStyle": "에셋 스타일",
    "insertAssetPrompt": "에셋 프롬프트 삽입",
    "requestLocation": "리퀘스트 위치",
    "newImageHandlingBeta": "새로운 이미지 처리 (베타)",
    "settingsExported": "버그 리포트용 설정이 내보내지고 클립보드에 복사되었습니다.",
    "bookmarks": "북마크",
    "noBookmarks": "북마크 없음",
    "bookmarkAskNameOrDefault": "북마크 이름을 입력하세요. 입력하지 않으면 자동으로 할당됩니다.",
    "bookmarkAskNameOrCancel": "북마크 이름을 입력하세요. 입력하지 않으면 이름 변경이 취소됩니다.",
    "collapseAll": "모두 접기",
    "expandAll": "모두 펼치기",
    "hideErrorDetails": "오류 세부사항 숨기기",
    "showErrorDetails": "오류 세부사항 보이기",
    "dynamicOutput": "동적 출력",
    "autoAdjustSchema": "스키마 자동 조정",
    "dynamicMessages": "동적 메시지",
    "dynamicMemory": "동적 메모리",
    "dynamicResponseTiming": "동적 응답 타이밍",
    "showTypingEffect": "타이핑 효과 표시",
    "dynamicRequest": "동적 요청",
    "dynamicOutputPrompt": "동적 출력 프롬프트",
    "settingsCloseButtonSize": "설정 닫기 버튼 크기",
    "translating": "번역 중...",
    "stackTraceTranslationFailed": "스택 트레이스 번역에 실패했습니다. 아래에 원래 난독화된 스택 트레이스를 표시합니다.",
    "translate": "코드 주소 번역하기",
    "apply": "적용",
    "add": "추가",
    "nightlyWarning": "## 나이틀리 빌드\n\n나이틀리 빌드에 연결하려고 합니다. 이 버전은 테스트용이며 버그가 포함되어 있을 수 있습니다. **이 버전에서는 버그 등 문제가 발생하더라도 직접적으로 해결하는 것을 지원하지 않습니다.**",
    "loginSionyw": "Sionyw 계정으로 로그인",
    "pluginRiskDetectedAlert": "Risuai가 API 키나 개인 데이터를 훔칠 수도 있는 위험한 코드를 감지했습니다. 이 플러그인을 설치하지 않는 것을 권장합니다.",
    "doNotInstall": "설치하지 않음",
    "continueAnyway": "무시하고 계속",
    "pluginNoRiskButAlert": "Risuai가 위험한 코드를 감지하지 못했지만, 신뢰할 수 없는 출처의 플러그인을 설치하면 보안 위험이 발생할 수 있습니다.",
    "pluginRisksInuserFriendly": {
        "eval": "문자열에서 코드 실행",
        "globalAccess": "글로벌 변수 접근",
        "thisOutsideClass": "클래스 컨텍스트 외부에서 'this' 사용",
        "errorInVerification": "검증 과정 중 오류 발생",
        "storageAccess": "스토리지 접근"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "플러그인이 문자열에서 코드를 실행하려고 합니다. 악성 코드를 숨기기 위해 문자열이 난독화되었을 수 있습니다.",
        "globalAccess": "플러그인이 글로벌 변수에 접근하려고 합니다. 이는 의도치 않은 부작용이나 보안 취약점으로 이어질 수 있습니다.",
        "thisOutsideClass": "플러그인이 클래스 컨텍스트 외부에서 'this' 키워드를 사용하고 있습니다. 이는 의도치 않은 동작이나 보안 문제로 이어질 수 있습니다.",
        "errorInVerification": "플러그인의 검증 과정 중 오류가 발생했습니다. 이는 기능상의 잠재적인 문제를 나타냅니다.",
        "storageAccess": "플러그인이 스토리지에 접근하려고 합니다. 이는 데이터 유출이나 무단 데이터 조작으로 이어질 수 있습니다."
    },
    "generatedByAIDisclaimer": "이 콘텐츠는 AI에 의해 생성되었으며 부정확하거나 편향된 정보가 포함될 수 있습니다.",
    "aiGenerationWarning": "콘텐츠는 AI로 생성되며 부정확하거나 편향된 정보가 포함될 수 있습니다.",
    "autoScrollToNewMessage": "새 메시지로 자동 스크롤",
    "alwaysScrollToNewMessage": "항상 새 메시지로 스크롤 (스크롤 위치 무시)",
    "newMessage": "새 메시지",
    "newMessageButtonStyle": "새 메시지 버튼 스타일",
    "newMessageButtonBottomCenter": "하단 중앙 (기본값)",
    "newMessageButtonBottomRight": "하단 우측",
    "newMessageButtonBottomLeft": "하단 좌측",
    "newMessageButtonFloatingCircle": "아이콘 원 (우측 하단)",
    "newMessageButtonRightCenter": "우측 중앙",
    "newMessageButtonTopBar": "상단 바",
    "goToChat": "채팅으로 이동",
    "duplicatePluginFoundUpdateIt": "중복된 플러그인이 발견되었습니다. 기존 플러그인을 업데이트하시겠습니까?",
    "loadMore": "더 보기",
    "pluginUpdateFoundInstallIt": "플러그인 업데이트가 발견되었습니다. 업데이트를 설치하시겠습니까?",
    "noRequestLogs": "요청 로그가 없습니다.",
    "branchedText": "이 채팅은 {}에서 분기되었습니다.",
    "disableMessage": "메시지 비활성화",
    "bookmark": "북마크",
    "branch": "분기점",
    "partialBackupFirstConfirm": "⚠️ 경고: 부분 로컬 백업 ⚠️\n\n이 백업은 최소한의 필수 정보만 빠르게 저장하는 기능입니다.\n\n포함되는 것:\n- 데이터베이스 (채팅 기록, 캐릭터, 모듈, 플러그인, 프롬프트, 설정 등)\n- 캐릭터 프로필 아이콘 (메인 이미지)\n- 사용자 아이콘 및 커스텀 배경\n- 페르소나 아이콘\n- 폴더 이미지\n- 봇 프리셋 이미지\n\n⚠️ 포함되지 않는 것:\n- 감정 이미지\n- 추가 캐릭터 에셋\n- VITS 음성 파일\n- 기타 모든 추가 미디어 파일\n\n이 백업 파일에는 모든 캐릭터 에셋이 포함되지 않습니다!\n완전한 백업이 필요하다면 일반 로컬 백업을 사용하세요.\n\n그래도 계속하시겠습니까?",
    "partialBackupSecondConfirm": "⚠️⚠️ 최종 경고 ⚠️⚠️\n\n이 백업은 캐릭터의 프로필 이미지만 저장하며, 나머지 대부분의 에셋은 저장하지 않습니다!\n\n저장되는 것:\n- 데이터베이스 (채팅 기록, 캐릭터, 모듈, 플러그인, 프롬프트, 설정 등)\n- 캐릭터 프로필 아이콘 (메인 이미지)\n- 사용자 아이콘 및 커스텀 배경\n- 페르소나 아이콘\n- 폴더 이미지\n- 봇 프리셋 이미지\n\n저장되지 않는 것:\n- 감정 이미지\n- 추가 캐릭터 에셋\n- VITS 음성 파일\n- 기타 모든 미디어 파일\n\n⚠️ 백업 파일에 캐릭터 에셋이 필요하지 않은 경우에만 진행하세요! ⚠️\n\n정말로 부분 백업을 진행하시겠습니까?",
    "savePartialLocalBackup": "부분 로컬 백업 저장 (캐릭터 에셋 제외)",
    "bootstrap": {
        "dataCorruptionDetected": (name: string, type: string) => `데이터 손상 감지\n\n모듈 "${name}"의 로어북 형식이 손상되었습니다.\n\n손상된 데이터 타입: ${type}`,
        "reportErrorQuestion": "다음 팝업 창에서 오류 정보를 복사한 후 개발자에게 보고하시겠습니까?\n같은 오류가 다시 발생하는 것을 막는 것에 큰 도움이 됩니다.\n(오류가 난 모듈 정보만 포함되며 다른 정보는 포함되지 않습니다)",
        "diagnosticInformation": (reportData: string) => `# 진단 정보\n\n아래 정보를 복사하여 GitHub Issues나 Discord, 커뮤니티를 통해 개발자에게 제보해주세요.\n제보 전에 민감한 정보가 있는지 다시 한번 확인해주세요:\n\n\`\`\`json\n${reportData}\n\`\`\``,
        "resetLorebookQuestion": "이 손상된 모듈의 로어북 데이터만 초기화하시겠습니까?\n(다른 모듈이나 캐릭터 데이터는 영향받지 않습니다)\n\"아니오\"를 선택하면 데이터가 그대로 유지되지만 오류가 계속 발생할 수 있습니다.",
    },
    "partialEdit": {
        "editButtonTooltip": "수정",
        "deleteButtonTooltip": "삭제",
        "deleteModalTitle": "삭제 확인",
        "deleteConfirmMessage": "이 부분을 삭제하시겠습니까?",
        "deleteYes": "예",
        "deleteNo": "아니오",
        "editModalTitle": "부분 수정",
        "matchFound": (method: string) => `매칭: ${method}`,
        "matchFailedTitle": "부분 수정 불가",
        "matchFailedMessage": "원본 메시지에서 정확한 위치를 찾을 수 없습니다. 매우 긴 문장이거나 중복된 내용인 경우 발생할 수 있습니다. 전체 메시지 수정 기능을 사용해주세요.",
        "selectMatch": "수정할 블록을 선택하세요",
        "selectDeleteMatch": "삭제할 블록을 선택하세요",
        "matchesFound": "개의 매칭을 찾음",
        "lineNumber": (line: number) => `약 ${line}줄`,
        "saveShortcut": "저장 (Ctrl+Enter)",
        "cancelShortcut": "취소 (Esc)",
        "save": "저장",
        "cancel": "취소",
    },
    "providerPermissionDenied": "사용자가 플러그인의 제공자 접근 권한을 거부했습니다.",
    "hamburgerButtonBottom": "메뉴 버튼을 사이드바 하단으로 이동",
    "keepSessionAlive": "세션 유지",
    "keepSessionAlivePip": "PIP 사용",
    "keepSessionAliveSound": "소리 사용",
    "nanoGPTLoadingAccountInfo": "계정 정보 불러오는 중…",
    "nanoGPTCreditBalance": "크레딧 잔액:",
    "nanoGPTSubscription": "구독",
    "nanoGPTGraceUntil": (date: string) => `${date}까지`,
    "nanoGPTNoActiveSubscription": "활성 구독이 없습니다.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `기간 종료 시 해지 (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `주간 포함 입력 토큰 — ${pct} 사용됨`,
    "nanoGPTDailyTokens": (pct: string) => `일간 포함 입력 토큰 — ${pct} 사용됨`,
    "nanoGPTDailyImages": (pct: string) => `일간 포함 이미지 — ${pct} 사용됨`,
    "nanoGPTResets": (date: string) => `${date}에 초기화`,
    "nanoGPTUsed": (n: string) => `${n} 사용됨`,
    "nanoGPTRemaining": (n: string) => `${n} 남음`,
    "nanoGPTRenews": (date: string) => `갱신일: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "계정 정보를 불러올 수 없습니다.",
    "nanoGPTWeeklyTokensLabel": "주간 포함 입력 토큰",
    "nanoGPTDailyTokensLabel": "일간 포함 입력 토큰",
    "nanoGPTDailyImagesLabel": "일간 포함 이미지",
    "nanoGPTUsedLabel": "사용됨",
    "nanoGPTRemainingLabel": "남음",
    "nanoGPTResetsLabel": "초기화",
    "nanoGPTRenewsLabel": "갱신일:",
    "nanoGPTProvider": "제공자",
    "nanoGPTProviderPayAsYouGoOnly": "(종량제 모드에서만 사용 가능)",
    "nanoGPTProviderAuto": "자동",
    "nanoGPTProviderFree": "무료",
    "nanoGPTProviderInput": "입력",
    "nanoGPTProviderOutput": "출력",
    "nanoGPTProviderQuantization": "양자화",
    "nanoGPTProviderUndisclosed": "미공개",
    "nanoGPTProviderCache": "캐시",
    "nanoGPTProviderCacheSupported": "지원",
    "nanoGPTProviderCacheNotSupported": "미지원",
    "nanoGPTProviderCacheRead": "캐시 읽기",
    "nanoGPTUseSubscriptionEndpoint": "구독 엔드포인트 및 모델 사용",
    "modelGridCouldNotLoad": "모델 목록을 불러올 수 없습니다. API 키를 확인해 주세요.",
    "modelGridNoModelsMatch": (q: string) => `"${q}"에 맞는 모델이 없습니다`,
    "modelGridContext": (n: string) => `컨텍스트: ${n}`,

    nanoGPTSelectFromList: "목록에서 선택",
    nanoGPTManualInput: "수동 입력",
    nanoGPTManualModelSelect: "수동 모델 선택",
    localToggles: "로컬 토글",
} satisfies DeepPartial<typeof import('./en').languageEnglish>
